function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! choices.js v6.0.3 | (c) 2019 Josh Johnson | https://github.com/jshjohnson/Choices#readme */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Choices = t() : e.Choices = t();
}(window, function () {
  return function (e) {
    var t = {};

    function i(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
    }

    return i.m = e, i.c = t, i.d = function (e, t, n) {
      i.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, i.t = function (e, t) {
      if (1 & t && (e = i(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var n = Object.create(null);
      if (i.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        i.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, i.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return i.d(t, "a", t), t;
    }, i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.p = "/public/assets/scripts/", i(i.s = 9);
  }([function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.diff = t.cloneObject = t.existsInArray = t.isIE11 = t.fetchFromObject = t.getWindowHeight = t.dispatchEvent = t.sortByScore = t.sortByAlpha = t.calcWidthOfInput = t.strToEl = t.sanitise = t.isScrolledIntoView = t.getAdjacentEl = t.findAncestorByAttrName = t.wrap = t.isElement = t.isType = t.getType = t.generateId = t.generateChars = t.getRandomNumber = void 0;

    var n = function n(e, t) {
      return Math.floor(Math.random() * (t - e) + e);
    };

    t.getRandomNumber = n;

    var r = function r(e) {
      for (var t = "", i = 0; i < e; i++) {
        t += n(0, 36).toString(36);
      }

      return t;
    };

    t.generateChars = r;

    t.generateId = function (e, t) {
      var i = e.id || e.name && "".concat(e.name, "-").concat(r(2)) || r(4);
      return i = i.replace(/(:|\.|\[|\]|,)/g, ""), i = "".concat(t, "-").concat(i);
    };

    var o = function o(e) {
      return Object.prototype.toString.call(e).slice(8, -1);
    };

    t.getType = o;

    var s = function s(e, t) {
      return null != t && o(t) === e;
    };

    t.isType = s;

    t.isElement = function (e) {
      return e instanceof Element;
    };

    t.wrap = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document.createElement("div");
      return e.nextSibling ? e.parentNode.insertBefore(t, e.nextSibling) : e.parentNode.appendChild(t), t.appendChild(e);
    };

    t.findAncestorByAttrName = function (e, t) {
      for (var i = e; i;) {
        if (i.hasAttribute(t)) return i;
        i = i.parentElement;
      }

      return null;
    };

    t.getAdjacentEl = function (e, t) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;

      if (e && t) {
        var n = e.parentNode.parentNode,
            r = Array.from(n.querySelectorAll(t)),
            o = r.indexOf(e);
        return r[o + (i > 0 ? 1 : -1)];
      }
    };

    t.isScrolledIntoView = function (e, t) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
      if (e) return i > 0 ? t.scrollTop + t.offsetHeight >= e.offsetTop + e.offsetHeight : e.offsetTop >= t.scrollTop;
    };

    var a = function a(e) {
      return s("String", e) ? e.replace(/&/g, "&amp;").replace(/>/g, "&rt;").replace(/</g, "&lt;").replace(/"/g, "&quot;") : e;
    };

    t.sanitise = a;
    var c,
        l = (c = document.createElement("div"), function (e) {
      var t = e.trim();
      c.innerHTML = t;

      for (var i = c.children[0]; c.firstChild;) {
        c.removeChild(c.firstChild);
      }

      return i;
    });
    t.strToEl = l;

    t.calcWidthOfInput = function (e, t) {
      var i = e.value || e.placeholder,
          n = e.offsetWidth;

      if (i) {
        var r = l("<span>".concat(a(i), "</span>"));

        if (r.style.position = "absolute", r.style.padding = "0", r.style.top = "-9999px", r.style.left = "-9999px", r.style.width = "auto", r.style.whiteSpace = "pre", document.body.contains(e) && window.getComputedStyle) {
          var o = window.getComputedStyle(e);
          o && (r.style.fontSize = o.fontSize, r.style.fontFamily = o.fontFamily, r.style.fontWeight = o.fontWeight, r.style.fontStyle = o.fontStyle, r.style.letterSpacing = o.letterSpacing, r.style.textTransform = o.textTransform, r.style.padding = o.padding);
        }

        document.body.appendChild(r), requestAnimationFrame(function () {
          i && r.offsetWidth !== e.offsetWidth && (n = r.offsetWidth + 4), document.body.removeChild(r), t.call(void 0, "".concat(n, "px"));
        });
      } else t.call(void 0, "".concat(n, "px"));
    };

    t.sortByAlpha = function (e, t) {
      var i = "".concat(e.label || e.value).toLowerCase(),
          n = "".concat(t.label || t.value).toLowerCase();
      return i < n ? -1 : i > n ? 1 : 0;
    };

    t.sortByScore = function (e, t) {
      return e.score - t.score;
    };

    t.dispatchEvent = function (e, t) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          n = new CustomEvent(t, {
        detail: i,
        bubbles: !0,
        cancelable: !0
      });
      return e.dispatchEvent(n);
    };

    t.getWindowHeight = function () {
      var e = document.body,
          t = document.documentElement;
      return Math.max(e.scrollHeight, e.offsetHeight, t.clientHeight, t.scrollHeight, t.offsetHeight);
    };

    t.fetchFromObject = function e(t, i) {
      var n = i.indexOf(".");
      return n > -1 ? e(t[i.substring(0, n)], i.substr(n + 1)) : t[i];
    };

    t.isIE11 = function () {
      return !(!navigator.userAgent.match(/Trident/) || !navigator.userAgent.match(/rv[ :]11/));
    };

    t.existsInArray = function (e, t) {
      var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "value";
      return e.some(function (e) {
        return s("String", t) ? e[i] === t.trim() : e[i] === t;
      });
    };

    t.cloneObject = function (e) {
      return JSON.parse(JSON.stringify(e));
    };

    t.diff = function (e, t) {
      var i = Object.keys(e).sort(),
          n = Object.keys(t).sort();
      return i.filter(function (e) {
        return n.indexOf(e) < 0;
      });
    };
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SCROLLING_SPEED = t.KEY_CODES = t.ACTION_TYPES = t.EVENTS = t.DEFAULT_CONFIG = t.DEFAULT_CLASSNAMES = void 0;
    var n = i(0),
        r = {
      containerOuter: "choices",
      containerInner: "choices__inner",
      input: "choices__input",
      inputCloned: "choices__input--cloned",
      list: "choices__list",
      listItems: "choices__list--multiple",
      listSingle: "choices__list--single",
      listDropdown: "choices__list--dropdown",
      item: "choices__item",
      itemSelectable: "choices__item--selectable",
      itemDisabled: "choices__item--disabled",
      itemChoice: "choices__item--choice",
      placeholder: "choices__placeholder",
      group: "choices__group",
      groupHeading: "choices__heading",
      button: "choices__button",
      activeState: "is-active",
      focusState: "is-focused",
      openState: "is-open",
      disabledState: "is-disabled",
      highlightedState: "is-highlighted",
      hiddenState: "is-hidden",
      flippedState: "is-flipped",
      loadingState: "is-loading",
      noResults: "has-no-results",
      noChoices: "has-no-choices"
    };
    t.DEFAULT_CLASSNAMES = r;
    var o = {
      items: [],
      choices: [],
      silent: !1,
      renderChoiceLimit: -1,
      maxItemCount: -1,
      addItems: !0,
      addItemFilterFn: null,
      removeItems: !0,
      removeItemButton: !1,
      editItems: !1,
      duplicateItemsAllowed: !0,
      delimiter: ",",
      paste: !0,
      searchEnabled: !0,
      searchChoices: !0,
      searchFloor: 1,
      searchResultLimit: 4,
      searchFields: ["label", "value"],
      position: "auto",
      resetScrollPosition: !0,
      shouldSort: !0,
      shouldSortItems: !1,
      sortFn: n.sortByAlpha,
      placeholder: !0,
      placeholderValue: null,
      searchPlaceholderValue: null,
      prependValue: null,
      appendValue: null,
      renderSelectedChoices: "auto",
      loadingText: "Loading...",
      noResultsText: "No results found",
      noChoicesText: "No choices to choose from",
      itemSelectText: "Press to select",
      uniqueItemText: "Only unique values can be added",
      customAddItemText: "Only values matching specific conditions can be added",
      addItemText: function addItemText(e) {
        return 'Press Enter to add <b>"'.concat((0, n.sanitise)(e), '"</b>');
      },
      maxItemText: function maxItemText(e) {
        return "Only ".concat(e, " values can be added");
      },
      itemComparer: function itemComparer(e, t) {
        return e === t;
      },
      fuseOptions: {
        includeScore: !0
      },
      callbackOnInit: null,
      callbackOnCreateTemplates: null,
      classNames: r
    };
    t.DEFAULT_CONFIG = o;
    t.EVENTS = {
      showDropdown: "showDropdown",
      hideDropdown: "hideDropdown",
      change: "change",
      choice: "choice",
      search: "search",
      addItem: "addItem",
      removeItem: "removeItem",
      highlightItem: "highlightItem",
      highlightChoice: "highlightChoice"
    };
    t.ACTION_TYPES = {
      ADD_CHOICE: "ADD_CHOICE",
      FILTER_CHOICES: "FILTER_CHOICES",
      ACTIVATE_CHOICES: "ACTIVATE_CHOICES",
      CLEAR_CHOICES: "CLEAR_CHOICES",
      ADD_GROUP: "ADD_GROUP",
      ADD_ITEM: "ADD_ITEM",
      REMOVE_ITEM: "REMOVE_ITEM",
      HIGHLIGHT_ITEM: "HIGHLIGHT_ITEM",
      CLEAR_ALL: "CLEAR_ALL"
    };
    t.KEY_CODES = {
      BACK_KEY: 46,
      DELETE_KEY: 8,
      ENTER_KEY: 13,
      A_KEY: 65,
      ESC_KEY: 27,
      UP_KEY: 38,
      DOWN_KEY: 40,
      PAGE_UP_KEY: 33,
      PAGE_DOWN_KEY: 34
    };
    t.SCROLLING_SPEED = 4;
  }, function (e, t, i) {
    "use strict";

    (function (e, n) {
      var r,
          o = i(7);
      r = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : n;
      var s = Object(o.a)(r);
      t.a = s;
    }).call(this, i(3), i(16)(e));
  }, function (e, t) {
    var i;

    i = function () {
      return this;
    }();

    try {
      i = i || new Function("return this")();
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (i = window);
    }

    e.exports = i;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n = i(0);

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    var o = function () {
      function e(t) {
        var i = t.element,
            r = t.classNames;
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Object.assign(this, {
          element: i,
          classNames: r
        }), !(0, n.isElement)(i)) throw new TypeError("Invalid element passed");
        this.isDisabled = !1;
      }

      var t, i, o;
      return t = e, (i = [{
        key: "conceal",
        value: function value() {
          this.element.classList.add(this.classNames.input), this.element.classList.add(this.classNames.hiddenState), this.element.tabIndex = "-1";
          var e = this.element.getAttribute("style");
          e && this.element.setAttribute("data-choice-orig-style", e), this.element.setAttribute("aria-hidden", "true"), this.element.setAttribute("data-choice", "active");
        }
      }, {
        key: "reveal",
        value: function value() {
          this.element.classList.remove(this.classNames.input), this.element.classList.remove(this.classNames.hiddenState), this.element.removeAttribute("tabindex");
          var e = this.element.getAttribute("data-choice-orig-style");
          e ? (this.element.removeAttribute("data-choice-orig-style"), this.element.setAttribute("style", e)) : this.element.removeAttribute("style"), this.element.removeAttribute("aria-hidden"), this.element.removeAttribute("data-choice"), this.element.value = this.element.value;
        }
      }, {
        key: "enable",
        value: function value() {
          this.element.removeAttribute("disabled"), this.element.disabled = !1, this.isDisabled = !1;
        }
      }, {
        key: "disable",
        value: function value() {
          this.element.setAttribute("disabled", ""), this.element.disabled = !0, this.isDisabled = !0;
        }
      }, {
        key: "triggerEvent",
        value: function value(e, t) {
          (0, n.dispatchEvent)(this.element, e, t);
        }
      }, {
        key: "value",
        get: function get() {
          return this.element.value;
        }
      }]) && r(t.prototype, i), o && r(t, o), e;
    }();

    t["default"] = o;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = t.TEMPLATES = void 0;
    var n,
        r = (n = i(29)) && n.__esModule ? n : {
      "default": n
    },
        o = i(0);

    function s(e, t, i) {
      return t in e ? Object.defineProperty(e, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = i, e;
    }

    var a = {
      containerOuter: function containerOuter(e, t, i, n, r, s) {
        var a = n ? 'tabindex="0"' : "",
            c = i ? 'role="listbox"' : "",
            l = "";
        return i && r && (c = 'role="combobox"', l = 'aria-autocomplete="list"'), (0, o.strToEl)('\n      <div\n        class="'.concat(e.containerOuter, '"\n        data-type="').concat(s, '"\n        ').concat(c, "\n        ").concat(a, "\n        ").concat(l, '\n        aria-haspopup="true"\n        aria-expanded="false"\n        dir="').concat(t, '"\n        >\n      </div>\n    '));
      },
      containerInner: function containerInner(e) {
        return (0, o.strToEl)('\n      <div class="'.concat(e.containerInner, '"></div>\n    '));
      },
      itemList: function itemList(e, t) {
        var i,
            n = (0, r["default"])(e.list, (s(i = {}, e.listSingle, t), s(i, e.listItems, !t), i));
        return (0, o.strToEl)('\n      <div class="'.concat(n, '"></div>\n    '));
      },
      placeholder: function placeholder(e, t) {
        return (0, o.strToEl)('\n      <div class="'.concat(e.placeholder, '">\n        ').concat(t, "\n      </div>\n    "));
      },
      item: function item(e, t, i) {
        var n,
            a,
            c = t.active ? 'aria-selected="true"' : "",
            l = t.disabled ? 'aria-disabled="true"' : "",
            u = (0, r["default"])(e.item, (s(n = {}, e.highlightedState, t.highlighted), s(n, e.itemSelectable, !t.highlighted), s(n, e.placeholder, t.placeholder), n));
        return i ? (u = (0, r["default"])(e.item, (s(a = {}, e.highlightedState, t.highlighted), s(a, e.itemSelectable, !t.disabled), s(a, e.placeholder, t.placeholder), a)), (0, o.strToEl)('\n        <div\n          class="'.concat(u, '"\n          data-item\n          data-id="').concat(t.id, '"\n          data-value="').concat(t.value, "\"\n          data-custom-properties='").concat(t.customProperties, "'\n          data-deletable\n          ").concat(c, "\n          ").concat(l, "\n          >\n          ").concat(t.label, '\x3c!--\n       --\x3e<button\n            type="button"\n            class="').concat(e.button, '"\n            data-button\n            aria-label="Remove item: \'').concat(t.value, "'\"\n            >\n            Remove item\n          </button>\n        </div>\n      "))) : (0, o.strToEl)('\n      <div\n        class="'.concat(u, '"\n        data-item\n        data-id="').concat(t.id, '"\n        data-value="').concat(t.value, '"\n        ').concat(c, "\n        ").concat(l, "\n        >\n        ").concat(t.label, "\n      </div>\n    "));
      },
      choiceList: function choiceList(e, t) {
        var i = t ? "" : 'aria-multiselectable="true"';
        return (0, o.strToEl)('\n      <div\n        class="'.concat(e.list, '"\n        dir="ltr"\n        role="listbox"\n        ').concat(i, "\n        >\n      </div>\n    "));
      },
      choiceGroup: function choiceGroup(e, t) {
        var i = t.disabled ? 'aria-disabled="true"' : "",
            n = (0, r["default"])(e.group, s({}, e.itemDisabled, t.disabled));
        return (0, o.strToEl)('\n      <div\n        class="'.concat(n, '"\n        data-group\n        data-id="').concat(t.id, '"\n        data-value="').concat(t.value, '"\n        role="group"\n        ').concat(i, '\n        >\n        <div class="').concat(e.groupHeading, '">').concat(t.value, "</div>\n      </div>\n    "));
      },
      choice: function choice(e, t, i) {
        var n,
            a = t.groupId > 0 ? 'role="treeitem"' : 'role="option"',
            c = (0, r["default"])(e.item, e.itemChoice, (s(n = {}, e.itemDisabled, t.disabled), s(n, e.itemSelectable, !t.disabled), s(n, e.placeholder, t.placeholder), n));
        return (0, o.strToEl)('\n      <div\n        class="'.concat(c, '"\n        data-select-text="').concat(i, '"\n        data-choice\n        data-id="').concat(t.id, '"\n        data-value="').concat(t.value, '"\n        ').concat(t.disabled ? 'data-choice-disabled aria-disabled="true"' : "data-choice-selectable", '\n        id="').concat(t.elementId, '"\n        ').concat(a, "\n        >\n        ").concat(t.label, "\n      </div>\n    "));
      },
      input: function input(e) {
        var t = (0, r["default"])(e.input, e.inputCloned);
        return (0, o.strToEl)('\n      <input\n        type="text"\n        class="'.concat(t, '"\n        autocomplete="off"\n        autocapitalize="off"\n        spellcheck="false"\n        role="textbox"\n        aria-autocomplete="list"\n        >\n    '));
      },
      dropdown: function dropdown(e) {
        var t = (0, r["default"])(e.list, e.listDropdown);
        return (0, o.strToEl)('\n      <div\n        class="'.concat(t, '"\n        aria-expanded="false"\n        >\n      </div>\n    '));
      },
      notice: function notice(e, t) {
        var i,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
            a = (0, r["default"])(e.item, e.itemChoice, (s(i = {}, e.noResults, "no-results" === n), s(i, e.noChoices, "no-choices" === n), i));
        return (0, o.strToEl)('\n      <div class="'.concat(a, '">\n        ').concat(t, "\n      </div>\n    "));
      },
      option: function option(e) {
        return (0, o.strToEl)('\n      <option value="'.concat(e.value, '" ').concat(e.active ? "selected" : "", " ").concat(e.disabled ? "disabled" : "", " ").concat(e.customProperties ? "data-custom-properties=".concat(e.customProperties) : "", ">").concat(e.label, "</option>\n    "));
      }
    };
    t.TEMPLATES = a;
    var c = a;
    t["default"] = c;
  }, function (e, t, i) {
    "use strict";

    i.r(t);
    var n = i(8),
        r = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
        o = (n.a || r || Function("return this")()).Symbol,
        s = Object.prototype,
        a = s.hasOwnProperty,
        c = s.toString,
        l = o ? o.toStringTag : void 0;

    var u = function u(e) {
      var t = a.call(e, l),
          i = e[l];

      try {
        e[l] = void 0;
        var n = !0;
      } catch (e) {}

      var r = c.call(e);
      return n && (t ? e[l] = i : delete e[l]), r;
    },
        h = Object.prototype.toString;

    var d = function d(e) {
      return h.call(e);
    },
        f = "[object Null]",
        p = "[object Undefined]",
        v = o ? o.toStringTag : void 0;

    var m = function m(e) {
      return null == e ? void 0 === e ? p : f : v && v in Object(e) ? u(e) : d(e);
    };

    var g = function (e, t) {
      return function (i) {
        return e(t(i));
      };
    }(Object.getPrototypeOf, Object);

    var _ = function _(e) {
      return null != e && "object" == _typeof(e);
    },
        y = "[object Object]",
        b = Function.prototype,
        E = Object.prototype,
        S = b.toString,
        I = E.hasOwnProperty,
        O = S.call(Object);

    var C = function C(e) {
      if (!_(e) || m(e) != y) return !1;
      var t = g(e);
      if (null === t) return !0;
      var i = I.call(t, "constructor") && t.constructor;
      return "function" == typeof i && i instanceof i && S.call(i) == O;
    },
        T = i(2),
        w = {
      INIT: "@@redux/INIT"
    };

    function k(e, t, i) {
      var n;

      if ("function" == typeof t && void 0 === i && (i = t, t = void 0), void 0 !== i) {
        if ("function" != typeof i) throw new Error("Expected the enhancer to be a function.");
        return i(k)(e, t);
      }

      if ("function" != typeof e) throw new Error("Expected the reducer to be a function.");
      var r = e,
          o = t,
          s = [],
          a = s,
          c = !1;

      function l() {
        a === s && (a = s.slice());
      }

      function u() {
        return o;
      }

      function h(e) {
        if ("function" != typeof e) throw new Error("Expected listener to be a function.");
        var t = !0;
        return l(), a.push(e), function () {
          if (t) {
            t = !1, l();
            var i = a.indexOf(e);
            a.splice(i, 1);
          }
        };
      }

      function d(e) {
        if (!C(e)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (void 0 === e.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (c) throw new Error("Reducers may not dispatch actions.");

        try {
          c = !0, o = r(o, e);
        } finally {
          c = !1;
        }

        for (var t = s = a, i = 0; i < t.length; i++) {
          (0, t[i])();
        }

        return e;
      }

      return d({
        type: w.INIT
      }), (n = {
        dispatch: d,
        subscribe: h,
        getState: u,
        replaceReducer: function replaceReducer(e) {
          if ("function" != typeof e) throw new Error("Expected the nextReducer to be a function.");
          r = e, d({
            type: w.INIT
          });
        }
      })[T.a] = function () {
        var e,
            t = h;
        return (e = {
          subscribe: function subscribe(e) {
            if ("object" != _typeof(e)) throw new TypeError("Expected the observer to be an object.");

            function i() {
              e.next && e.next(u());
            }

            return i(), {
              unsubscribe: t(i)
            };
          }
        })[T.a] = function () {
          return this;
        }, e;
      }, n;
    }

    function A(e, t) {
      var i = t && t.type;
      return "Given action " + (i && '"' + i.toString() + '"' || "an action") + ', reducer "' + e + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.';
    }

    function L(e) {
      for (var t = Object.keys(e), i = {}, n = 0; n < t.length; n++) {
        var r = t[n];
        0, "function" == typeof e[r] && (i[r] = e[r]);
      }

      var o = Object.keys(i);
      var s = void 0;

      try {
        !function (e) {
          Object.keys(e).forEach(function (t) {
            var i = e[t];
            if (void 0 === i(void 0, {
              type: w.INIT
            })) throw new Error('Reducer "' + t + "\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");
            if (void 0 === i(void 0, {
              type: "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".")
            })) throw new Error('Reducer "' + t + "\" returned undefined when probed with a random type. Don't try to handle " + w.INIT + ' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.');
          });
        }(i);
      } catch (e) {
        s = e;
      }

      return function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = arguments[1];
        if (s) throw s;

        for (var n = !1, r = {}, a = 0; a < o.length; a++) {
          var c = o[a],
              l = i[c],
              u = e[c],
              h = l(u, t);

          if (void 0 === h) {
            var d = A(c, t);
            throw new Error(d);
          }

          r[c] = h, n = n || h !== u;
        }

        return n ? r : e;
      };
    }

    function P(e, t) {
      return function () {
        return t(e.apply(void 0, arguments));
      };
    }

    function x(e, t) {
      if ("function" == typeof e) return P(e, t);
      if ("object" != _typeof(e) || null === e) throw new Error("bindActionCreators expected an object or a function, instead received " + (null === e ? "null" : _typeof(e)) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');

      for (var i = Object.keys(e), n = {}, r = 0; r < i.length; r++) {
        var o = i[r],
            s = e[o];
        "function" == typeof s && (n[o] = P(s, t));
      }

      return n;
    }

    function D() {
      for (var e = arguments.length, t = Array(e), i = 0; i < e; i++) {
        t[i] = arguments[i];
      }

      return 0 === t.length ? function (e) {
        return e;
      } : 1 === t.length ? t[0] : t.reduce(function (e, t) {
        return function () {
          return e(t.apply(void 0, arguments));
        };
      });
    }

    var j = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var i = arguments[t];

        for (var n in i) {
          Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
        }
      }

      return e;
    };

    function M() {
      for (var e = arguments.length, t = Array(e), i = 0; i < e; i++) {
        t[i] = arguments[i];
      }

      return function (e) {
        return function (i, n, r) {
          var o,
              s = e(i, n, r),
              a = s.dispatch,
              c = {
            getState: s.getState,
            dispatch: function dispatch(e) {
              return a(e);
            }
          };
          return o = t.map(function (e) {
            return e(c);
          }), a = D.apply(void 0, o)(s.dispatch), j({}, s, {
            dispatch: a
          });
        };
      };
    }

    i.d(t, "createStore", function () {
      return k;
    }), i.d(t, "combineReducers", function () {
      return L;
    }), i.d(t, "bindActionCreators", function () {
      return x;
    }), i.d(t, "applyMiddleware", function () {
      return M;
    }), i.d(t, "compose", function () {
      return D;
    });
  }, function (e, t, i) {
    "use strict";

    function n(e) {
      var t,
          i = e.Symbol;
      return "function" == typeof i ? i.observable ? t = i.observable : (t = i("observable"), i.observable = t) : t = "@@observable", t;
    }

    i.d(t, "a", function () {
      return n;
    });
  }, function (e, t, i) {
    "use strict";

    (function (e) {
      var i = "object" == _typeof(e) && e && e.Object === Object && e;
      t.a = i;
    }).call(this, i(3));
  }, function (e, t, i) {
    e.exports = i(10);
  }, function (e, t, i) {
    "use strict";

    var n = v(i(11)),
        r = v(i(12));
    i(13);
    var o = v(i(15)),
        s = i(22),
        a = i(1),
        c = i(5),
        l = i(30),
        u = i(31),
        h = i(32),
        d = i(33),
        f = i(34),
        p = i(0);

    function v(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function m(e, t, i) {
      return t in e ? Object.defineProperty(e, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = i, e;
    }

    function g(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    var _ = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "[data-choice]",
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), (0, p.isType)("String", t)) {
          var n = Array.from(document.querySelectorAll(t));
          if (n.length > 1) return this._generateInstances(n, i);
        }

        this.config = r["default"].all([a.DEFAULT_CONFIG, e.userDefaults, i], {
          arrayMerge: function arrayMerge(e, t) {
            return [].concat(t);
          }
        });
        var c = (0, p.diff)(this.config, a.DEFAULT_CONFIG);
        c.length && console.warn("Unknown config option(s) passed", c.join(", ")), ["auto", "always"].includes(this.config.renderSelectedChoices) || (this.config.renderSelectedChoices = "auto");
        var l = (0, p.isType)("String", t) ? document.querySelector(t) : t;
        return l ? (this._isTextElement = "text" === l.type, this._isSelectOneElement = "select-one" === l.type, this._isSelectMultipleElement = "select-multiple" === l.type, this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement, this._isTextElement ? this.passedElement = new s.WrappedInput({
          element: l,
          classNames: this.config.classNames,
          delimiter: this.config.delimiter
        }) : this._isSelectElement && (this.passedElement = new s.WrappedSelect({
          element: l,
          classNames: this.config.classNames
        })), this.passedElement ? (!0 === this.config.shouldSortItems && this._isSelectOneElement && !this.config.silent && console.warn("shouldSortElements: Type of passed element is 'select-one', falling back to false."), this.initialised = !1, this._store = new o["default"](this.render), this._initialState = {}, this._currentState = {}, this._prevState = {}, this._currentValue = "", this._canSearch = this.config.searchEnabled, this._isScrollingOnIe = !1, this._highlightPosition = 0, this._wasTap = !0, this._placeholderValue = this._generatePlaceholderValue(), this._baseId = (0, p.generateId)(this.passedElement.element, "choices-"), this._direction = this.passedElement.element.getAttribute("dir") || "ltr", this._idNames = {
          itemChoice: "item-choice"
        }, this._presetChoices = this.config.choices, this._presetItems = this.config.items, this.passedElement.value && (this._presetItems = this._presetItems.concat(this.passedElement.value.split(this.config.delimiter))), this._render = this._render.bind(this), this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this), this._onKeyUp = this._onKeyUp.bind(this), this._onKeyDown = this._onKeyDown.bind(this), this._onClick = this._onClick.bind(this), this._onTouchMove = this._onTouchMove.bind(this), this._onTouchEnd = this._onTouchEnd.bind(this), this._onMouseDown = this._onMouseDown.bind(this), this._onMouseOver = this._onMouseOver.bind(this), this._onFormReset = this._onFormReset.bind(this), this._onAKey = this._onAKey.bind(this), this._onEnterKey = this._onEnterKey.bind(this), this._onEscapeKey = this._onEscapeKey.bind(this), this._onDirectionKey = this._onDirectionKey.bind(this), this._onDeleteKey = this._onDeleteKey.bind(this), "active" === this.passedElement.element.getAttribute("data-choice") && console.warn("Trying to initialise Choices on element already initialised"), void this.init()) : console.error("Passed element was of an invalid type")) : console.error("Could not find passed element or passed element was of an invalid type");
      }

      var t, i, v;
      return t = e, (i = [{
        key: "init",
        value: function value() {
          if (!this.initialised) {
            this._createTemplates(), this._createElements(), this._createStructure(), this._initialState = (0, p.cloneObject)(this._store.state), this._store.subscribe(this._render), this._render(), this._addEventListeners(), (!this.config.addItems || this.passedElement.element.hasAttribute("disabled")) && this.disable(), this.initialised = !0;
            var e = this.config.callbackOnInit;
            e && (0, p.isType)("Function", e) && e.call(this);
          }
        }
      }, {
        key: "destroy",
        value: function value() {
          this.initialised && (this._removeEventListeners(), this.passedElement.reveal(), this.containerOuter.unwrap(this.passedElement.element), this._isSelectElement && (this.passedElement.options = this._presetChoices), this.clearStore(), this.config.templates = null, this.initialised = !1);
        }
      }, {
        key: "enable",
        value: function value() {
          return this.passedElement.isDisabled && this.passedElement.enable(), this.containerOuter.isDisabled && (this._addEventListeners(), this.input.enable(), this.containerOuter.enable()), this;
        }
      }, {
        key: "disable",
        value: function value() {
          return this.passedElement.isDisabled || this.passedElement.disable(), this.containerOuter.isDisabled || (this._removeEventListeners(), this.input.disable(), this.containerOuter.disable()), this;
        }
      }, {
        key: "highlightItem",
        value: function value(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          if (!e) return this;
          var i = e.id,
              n = e.groupId,
              r = void 0 === n ? -1 : n,
              o = e.value,
              s = void 0 === o ? "" : o,
              c = e.label,
              l = void 0 === c ? "" : c,
              h = r >= 0 ? this._store.getGroupById(r) : null;
          return this._store.dispatch((0, u.highlightItem)(i, !0)), t && this.passedElement.triggerEvent(a.EVENTS.highlightItem, {
            id: i,
            value: s,
            label: l,
            groupValue: h && h.value ? h.value : null
          }), this;
        }
      }, {
        key: "unhighlightItem",
        value: function value(e) {
          if (!e) return this;
          var t = e.id,
              i = e.groupId,
              n = void 0 === i ? -1 : i,
              r = e.value,
              o = void 0 === r ? "" : r,
              s = e.label,
              c = void 0 === s ? "" : s,
              l = n >= 0 ? this._store.getGroupById(n) : null;
          return this._store.dispatch((0, u.highlightItem)(t, !1)), this.passedElement.triggerEvent(a.EVENTS.highlightItem, {
            id: t,
            value: o,
            label: c,
            groupValue: l && l.value ? l.value : null
          }), this;
        }
      }, {
        key: "highlightAll",
        value: function value() {
          var e = this;
          return this._store.items.forEach(function (t) {
            return e.highlightItem(t);
          }), this;
        }
      }, {
        key: "unhighlightAll",
        value: function value() {
          var e = this;
          return this._store.items.forEach(function (t) {
            return e.unhighlightItem(t);
          }), this;
        }
      }, {
        key: "removeActiveItemsByValue",
        value: function value(e) {
          var t = this;
          return this._store.activeItems.filter(function (t) {
            return t.value === e;
          }).forEach(function (e) {
            return t._removeItem(e);
          }), this;
        }
      }, {
        key: "removeActiveItems",
        value: function value(e) {
          var t = this;
          return this._store.activeItems.filter(function (t) {
            return t.id !== e;
          }).forEach(function (e) {
            return t._removeItem(e);
          }), this;
        }
      }, {
        key: "removeHighlightedItems",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return this._store.highlightedActiveItems.forEach(function (i) {
            e._removeItem(i), t && e._triggerChange(i.value);
          }), this;
        }
      }, {
        key: "showDropdown",
        value: function value(e) {
          var t = this;
          return this.dropdown.isActive ? this : (requestAnimationFrame(function () {
            t.dropdown.show(), t.containerOuter.open(t.dropdown.distanceFromTopWindow()), !e && t._canSearch && t.input.focus(), t.passedElement.triggerEvent(a.EVENTS.showDropdown, {});
          }), this);
        }
      }, {
        key: "hideDropdown",
        value: function value(e) {
          var t = this;
          return this.dropdown.isActive ? (requestAnimationFrame(function () {
            t.dropdown.hide(), t.containerOuter.close(), !e && t._canSearch && (t.input.removeActiveDescendant(), t.input.blur()), t.passedElement.triggerEvent(a.EVENTS.hideDropdown, {});
          }), this) : this;
        }
      }, {
        key: "getValue",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              t = this._store.activeItems.reduce(function (t, i) {
            var n = e ? i.value : i;
            return t.push(n), t;
          }, []);

          return this._isSelectOneElement ? t[0] : t;
        }
      }, {
        key: "setValue",
        value: function value(e) {
          var t = this;
          return this.initialised ? ([].concat(e).forEach(function (e) {
            return t._setChoiceOrItem(e);
          }), this) : this;
        }
      }, {
        key: "setChoiceByValue",
        value: function value(e) {
          var t = this;
          return !this.initialised || this._isTextElement ? this : (((0, p.isType)("Array", e) ? e : [e]).forEach(function (e) {
            return t._findAndSelectChoiceByValue(e);
          }), this);
        }
      }, {
        key: "setChoices",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
              r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          if (!this._isSelectElement || !t.length || !i) return this;
          r && this._clearChoices(), this.containerOuter.removeLoadingState();
          return this._setLoading(!0), t.forEach(function (t) {
            t.choices ? e._addGroup({
              group: t,
              id: t.id || null,
              valueKey: i,
              labelKey: n
            }) : e._addChoice({
              value: t[i],
              label: t[n],
              isSelected: t.selected,
              isDisabled: t.disabled,
              customProperties: t.customProperties,
              placeholder: t.placeholder
            });
          }), this._setLoading(!1), this;
        }
      }, {
        key: "clearStore",
        value: function value() {
          return this._store.dispatch((0, d.clearAll)()), this;
        }
      }, {
        key: "clearInput",
        value: function value() {
          var e = !this._isSelectOneElement;
          return this.input.clear(e), !this._isTextElement && this._canSearch && (this._isSearching = !1, this._store.dispatch((0, l.activateChoices)(!0))), this;
        }
      }, {
        key: "ajax",
        value: function value(e) {
          var t = this;
          return this.initialised && this._isSelectElement && e ? (requestAnimationFrame(function () {
            return t._handleLoadingState(!0);
          }), e(this._ajaxCallback()), this) : this;
        }
      }, {
        key: "_render",
        value: function value() {
          if (!this._store.isLoading()) {
            this._currentState = this._store.state;
            var e = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items,
                t = this._isSelectElement,
                i = this._currentState.items !== this._prevState.items;
            e && (t && this._renderChoices(), i && this._renderItems(), this._prevState = this._currentState);
          }
        }
      }, {
        key: "_renderChoices",
        value: function value() {
          var e = this,
              t = this._store,
              i = t.activeGroups,
              n = t.activeChoices,
              r = document.createDocumentFragment();

          if (this.choiceList.clear(), this.config.resetScrollPosition && requestAnimationFrame(function () {
            return e.choiceList.scrollToTop();
          }), i.length >= 1 && !this._isSearching) {
            var o = n.filter(function (e) {
              return !0 === e.placeholder && -1 === e.groupId;
            });
            o.length >= 1 && (r = this._createChoicesFragment(o, r)), r = this._createGroupsFragment(i, n, r);
          } else n.length >= 1 && (r = this._createChoicesFragment(n, r));

          if (r.childNodes && r.childNodes.length > 0) {
            var s = this._store.activeItems,
                a = this._canAddItem(s, this.input.value);

            a.response ? (this.choiceList.append(r), this._highlightChoice()) : this.choiceList.append(this._getTemplate("notice", a.notice));
          } else {
            var c, l;
            this._isSearching ? (l = (0, p.isType)("Function", this.config.noResultsText) ? this.config.noResultsText() : this.config.noResultsText, c = this._getTemplate("notice", l, "no-results")) : (l = (0, p.isType)("Function", this.config.noChoicesText) ? this.config.noChoicesText() : this.config.noChoicesText, c = this._getTemplate("notice", l, "no-choices")), this.choiceList.append(c);
          }
        }
      }, {
        key: "_renderItems",
        value: function value() {
          var e = this._store.activeItems || [];
          this.itemList.clear();

          var t = this._createItemsFragment(e);

          t.childNodes && this.itemList.append(t);
        }
      }, {
        key: "_createGroupsFragment",
        value: function value(e, t, i) {
          var n = this,
              r = i || document.createDocumentFragment();
          return this.config.shouldSort && e.sort(this.config.sortFn), e.forEach(function (e) {
            var i = function (e) {
              return t.filter(function (t) {
                return n._isSelectOneElement ? t.groupId === e.id : t.groupId === e.id && ("always" === n.config.renderSelectedChoices || !t.selected);
              });
            }(e);

            if (i.length >= 1) {
              var o = n._getTemplate("choiceGroup", e);

              r.appendChild(o), n._createChoicesFragment(i, r, !0);
            }
          }), r;
        }
      }, {
        key: "_createChoicesFragment",
        value: function value(e, t) {
          var i = this,
              n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              r = t || document.createDocumentFragment(),
              o = this.config,
              s = o.renderSelectedChoices,
              a = o.searchResultLimit,
              c = o.renderChoiceLimit,
              l = this._isSearching ? p.sortByScore : this.config.sortFn,
              u = function u(e) {
            if ("auto" !== s || i._isSelectOneElement || !e.selected) {
              var t = i._getTemplate("choice", e, i.config.itemSelectText);

              r.appendChild(t);
            }
          },
              h = e;

          "auto" !== s || this._isSelectOneElement || (h = e.filter(function (e) {
            return !e.selected;
          }));
          var d = h.reduce(function (e, t) {
            return t.placeholder ? e.placeholderChoices.push(t) : e.normalChoices.push(t), e;
          }, {
            placeholderChoices: [],
            normalChoices: []
          }),
              f = d.placeholderChoices,
              v = d.normalChoices;
          (this.config.shouldSort || this._isSearching) && v.sort(l);
          var m = h.length,
              g = [].concat(f, v);
          this._isSearching ? m = a : c > 0 && !n && (m = c);

          for (var _ = 0; _ < m; _ += 1) {
            g[_] && u(g[_]);
          }

          return r;
        }
      }, {
        key: "_createItemsFragment",
        value: function value(e) {
          var t = this,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              n = this.config,
              r = n.shouldSortItems,
              o = n.sortFn,
              s = n.removeItemButton,
              a = i || document.createDocumentFragment();
          r && !this._isSelectOneElement && e.sort(o), this._isTextElement ? this.passedElement.value = e : this.passedElement.options = e;
          return e.forEach(function (e) {
            return function (e) {
              var i = t._getTemplate("item", e, s);

              a.appendChild(i);
            }(e);
          }), a;
        }
      }, {
        key: "_triggerChange",
        value: function value(e) {
          null != e && this.passedElement.triggerEvent(a.EVENTS.change, {
            value: e
          });
        }
      }, {
        key: "_selectPlaceholderChoice",
        value: function value() {
          var e = this._store.placeholderChoice;
          e && (this._addItem({
            value: e.value,
            label: e.label,
            choiceId: e.id,
            groupId: e.groupId,
            placeholder: e.placeholder
          }), this._triggerChange(e.value));
        }
      }, {
        key: "_handleButtonAction",
        value: function value(e, t) {
          if (e && t && this.config.removeItems && this.config.removeItemButton) {
            var i = t.parentNode.getAttribute("data-id"),
                n = e.find(function (e) {
              return e.id === parseInt(i, 10);
            });
            this._removeItem(n), this._triggerChange(n.value), this._isSelectOneElement && this._selectPlaceholderChoice();
          }
        }
      }, {
        key: "_handleItemAction",
        value: function value(e, t) {
          var i = this,
              n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];

          if (e && t && this.config.removeItems && !this._isSelectOneElement) {
            var r = t.getAttribute("data-id");
            e.forEach(function (e) {
              e.id !== parseInt(r, 10) || e.highlighted ? !n && e.highlighted && i.unhighlightItem(e) : i.highlightItem(e);
            }), this.input.focus();
          }
        }
      }, {
        key: "_handleChoiceAction",
        value: function value(e, t) {
          if (e && t) {
            var i = t.getAttribute("data-id"),
                n = this._store.getChoiceById(i),
                r = e[0] && e[0].keyCode ? e[0].keyCode : null,
                o = this.dropdown.isActive;

            if (n.keyCode = r, this.passedElement.triggerEvent(a.EVENTS.choice, {
              choice: n
            }), n && !n.selected && !n.disabled) this._canAddItem(e, n.value).response && (this._addItem({
              value: n.value,
              label: n.label,
              choiceId: n.id,
              groupId: n.groupId,
              customProperties: n.customProperties,
              placeholder: n.placeholder,
              keyCode: n.keyCode
            }), this._triggerChange(n.value));
            this.clearInput(), o && this._isSelectOneElement && (this.hideDropdown(!0), this.containerOuter.focus());
          }
        }
      }, {
        key: "_handleBackspace",
        value: function value(e) {
          if (this.config.removeItems && e) {
            var t = e[e.length - 1],
                i = e.some(function (e) {
              return e.highlighted;
            });
            this.config.editItems && !i && t ? (this.input.value = t.value, this.input.setWidth(), this._removeItem(t), this._triggerChange(t.value)) : (i || this.highlightItem(t, !1), this.removeHighlightedItems(!0));
          }
        }
      }, {
        key: "_setLoading",
        value: function value(e) {
          this._store.dispatch((0, f.setIsLoading)(e));
        }
      }, {
        key: "_handleLoadingState",
        value: function value() {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
              t = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
          e ? (this.disable(), this.containerOuter.addLoadingState(), this._isSelectOneElement ? t ? t.innerHTML = this.config.loadingText : (t = this._getTemplate("placeholder", this.config.loadingText), this.itemList.append(t)) : this.input.placeholder = this.config.loadingText) : (this.enable(), this.containerOuter.removeLoadingState(), this._isSelectOneElement ? t.innerHTML = this._placeholderValue || "" : this.input.placeholder = this._placeholderValue || "");
        }
      }, {
        key: "_handleSearch",
        value: function value(e) {
          if (e && this.input.isFocussed) {
            var t = this._store.choices,
                i = this.config,
                n = i.searchFloor,
                r = i.searchChoices,
                o = t.some(function (e) {
              return !e.active;
            });

            if (e && e.length >= n) {
              var s = r ? this._searchChoices(e) : 0;
              this.passedElement.triggerEvent(a.EVENTS.search, {
                value: e,
                resultCount: s
              });
            } else o && (this._isSearching = !1, this._store.dispatch((0, l.activateChoices)(!0)));
          }
        }
      }, {
        key: "_canAddItem",
        value: function value(e, t) {
          var i = !0,
              n = (0, p.isType)("Function", this.config.addItemText) ? this.config.addItemText(t) : this.config.addItemText;

          if (!this._isSelectOneElement) {
            var r = (0, p.existsInArray)(e, t);
            this.config.maxItemCount > 0 && this.config.maxItemCount <= e.length && (i = !1, n = (0, p.isType)("Function", this.config.maxItemText) ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText), !this.config.duplicateItemsAllowed && r && i && (i = !1, n = (0, p.isType)("Function", this.config.uniqueItemText) ? this.config.uniqueItemText(t) : this.config.uniqueItemText), this._isTextElement && this.config.addItems && i && (0, p.isType)("Function", this.config.addItemFilterFn) && !this.config.addItemFilterFn(t) && (i = !1, n = (0, p.isType)("Function", this.config.customAddItemText) ? this.config.customAddItemText(t) : this.config.customAddItemText);
          }

          return {
            response: i,
            notice: n
          };
        }
      }, {
        key: "_ajaxCallback",
        value: function value() {
          var e = this;
          return function (t, i, n) {
            if (t && i) {
              var r = (0, p.isType)("Object", t) ? [t] : t;
              r && (0, p.isType)("Array", r) && r.length ? (e._handleLoadingState(!1), e._setLoading(!0), r.forEach(function (t) {
                t.choices ? e._addGroup({
                  group: t,
                  id: t.id || null,
                  valueKey: i,
                  labelKey: n
                }) : e._addChoice({
                  value: (0, p.fetchFromObject)(t, i),
                  label: (0, p.fetchFromObject)(t, n),
                  isSelected: t.selected,
                  isDisabled: t.disabled,
                  customProperties: t.customProperties,
                  placeholder: t.placeholder
                });
              }), e._setLoading(!1), e._isSelectOneElement && e._selectPlaceholderChoice()) : e._handleLoadingState(!1);
            }
          };
        }
      }, {
        key: "_searchChoices",
        value: function value(e) {
          var t = (0, p.isType)("String", e) ? e.trim() : e,
              i = (0, p.isType)("String", this._currentValue) ? this._currentValue.trim() : this._currentValue;
          if (t.length < 1 && t === "".concat(i, " ")) return 0;
          var r = this._store.searchableChoices,
              o = t,
              s = [].concat(this.config.searchFields),
              a = Object.assign(this.config.fuseOptions, {
            keys: s
          }),
              c = new n["default"](r, a).search(o);
          return this._currentValue = t, this._highlightPosition = 0, this._isSearching = !0, this._store.dispatch((0, l.filterChoices)(c)), c.length;
        }
      }, {
        key: "_addEventListeners",
        value: function value() {
          document.addEventListener("keyup", this._onKeyUp), document.addEventListener("keydown", this._onKeyDown), document.addEventListener("click", this._onClick), document.addEventListener("touchmove", this._onTouchMove), document.addEventListener("touchend", this._onTouchEnd), document.addEventListener("mousedown", this._onMouseDown), document.addEventListener("mouseover", this._onMouseOver), this._isSelectOneElement && (this.containerOuter.element.addEventListener("focus", this._onFocus), this.containerOuter.element.addEventListener("blur", this._onBlur)), this.input.element.addEventListener("focus", this._onFocus), this.input.element.addEventListener("blur", this._onBlur), this.input.element.form && this.input.element.form.addEventListener("reset", this._onFormReset), this.input.addEventListeners();
        }
      }, {
        key: "_removeEventListeners",
        value: function value() {
          document.removeEventListener("keyup", this._onKeyUp), document.removeEventListener("keydown", this._onKeyDown), document.removeEventListener("click", this._onClick), document.removeEventListener("touchmove", this._onTouchMove), document.removeEventListener("touchend", this._onTouchEnd), document.removeEventListener("mousedown", this._onMouseDown), document.removeEventListener("mouseover", this._onMouseOver), this._isSelectOneElement && (this.containerOuter.element.removeEventListener("focus", this._onFocus), this.containerOuter.element.removeEventListener("blur", this._onBlur)), this.input.element.removeEventListener("focus", this._onFocus), this.input.element.removeEventListener("blur", this._onBlur), this.input.element.form && this.input.element.form.removeEventListener("reset", this._onFormReset), this.input.removeEventListeners();
        }
      }, {
        key: "_onKeyDown",
        value: function value(e) {
          var t,
              i = e.target,
              n = e.keyCode,
              r = e.ctrlKey,
              o = e.metaKey;

          if (i === this.input.element || this.containerOuter.element.contains(i)) {
            var s = this._store.activeItems,
                c = this.input.isFocussed,
                l = this.dropdown.isActive,
                u = this.itemList.hasChildren,
                h = String.fromCharCode(n),
                d = a.KEY_CODES.BACK_KEY,
                f = a.KEY_CODES.DELETE_KEY,
                p = a.KEY_CODES.ENTER_KEY,
                v = a.KEY_CODES.A_KEY,
                g = a.KEY_CODES.ESC_KEY,
                _ = a.KEY_CODES.UP_KEY,
                y = a.KEY_CODES.DOWN_KEY,
                b = a.KEY_CODES.PAGE_UP_KEY,
                E = a.KEY_CODES.PAGE_DOWN_KEY,
                S = r || o;
            !this._isTextElement && /[a-zA-Z0-9-_ ]/.test(h) && this.showDropdown();
            var I = (m(t = {}, v, this._onAKey), m(t, p, this._onEnterKey), m(t, g, this._onEscapeKey), m(t, _, this._onDirectionKey), m(t, b, this._onDirectionKey), m(t, y, this._onDirectionKey), m(t, E, this._onDirectionKey), m(t, f, this._onDeleteKey), m(t, d, this._onDeleteKey), t);
            I[n] && I[n]({
              event: e,
              target: i,
              keyCode: n,
              metaKey: o,
              activeItems: s,
              hasFocusedInput: c,
              hasActiveDropdown: l,
              hasItems: u,
              hasCtrlDownKeyPressed: S
            });
          }
        }
      }, {
        key: "_onKeyUp",
        value: function value(e) {
          var t = e.target,
              i = e.keyCode;

          if (t === this.input.element) {
            var n = this.input.value,
                r = this._store.activeItems,
                o = this._canAddItem(r, n),
                s = a.KEY_CODES.BACK_KEY,
                c = a.KEY_CODES.DELETE_KEY;

            if (this._isTextElement) {
              if (o.notice && n) {
                var u = this._getTemplate("notice", o.notice);

                this.dropdown.element.innerHTML = u.outerHTML, this.showDropdown(!0);
              } else this.hideDropdown(!0);
            } else {
              var h = (i === s || i === c) && !t.value,
                  d = !this._isTextElement && this._isSearching,
                  f = this._canSearch && o.response;
              h && d ? (this._isSearching = !1, this._store.dispatch((0, l.activateChoices)(!0))) : f && this._handleSearch(this.input.value);
            }

            this._canSearch = this.config.searchEnabled;
          }
        }
      }, {
        key: "_onAKey",
        value: function value(e) {
          var t = e.hasItems;
          e.hasCtrlDownKeyPressed && t && (this._canSearch = !1, this.config.removeItems && !this.input.value && this.input.element === document.activeElement && this.highlightAll());
        }
      }, {
        key: "_onEnterKey",
        value: function value(e) {
          var t = e.event,
              i = e.target,
              n = e.activeItems,
              r = e.hasActiveDropdown,
              o = a.KEY_CODES.ENTER_KEY,
              s = i.hasAttribute("data-button");

          if (this._isTextElement && i.value) {
            var c = this.input.value;
            this._canAddItem(n, c).response && (this.hideDropdown(!0), this._addItem({
              value: c
            }), this._triggerChange(c), this.clearInput());
          }

          if (s && (this._handleButtonAction(n, i), t.preventDefault()), r) {
            var l = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
            l && (n[0] && (n[0].keyCode = o), this._handleChoiceAction(n, l)), t.preventDefault();
          } else this._isSelectOneElement && (this.showDropdown(), t.preventDefault());
        }
      }, {
        key: "_onEscapeKey",
        value: function value(e) {
          e.hasActiveDropdown && (this.hideDropdown(!0), this.containerOuter.focus());
        }
      }, {
        key: "_onDirectionKey",
        value: function value(e) {
          var t = e.event,
              i = e.hasActiveDropdown,
              n = e.keyCode,
              r = e.metaKey,
              o = a.KEY_CODES.DOWN_KEY,
              s = a.KEY_CODES.PAGE_UP_KEY,
              c = a.KEY_CODES.PAGE_DOWN_KEY;

          if (i || this._isSelectOneElement) {
            this.showDropdown(), this._canSearch = !1;
            var l,
                u = n === o || n === c ? 1 : -1;
            if (r || n === c || n === s) l = u > 0 ? Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]")).pop() : this.dropdown.element.querySelector("[data-choice-selectable]");else {
              var h = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
              l = h ? (0, p.getAdjacentEl)(h, "[data-choice-selectable]", u) : this.dropdown.element.querySelector("[data-choice-selectable]");
            }
            l && ((0, p.isScrolledIntoView)(l, this.choiceList.element, u) || this.choiceList.scrollToChoice(l, u), this._highlightChoice(l)), t.preventDefault();
          }
        }
      }, {
        key: "_onDeleteKey",
        value: function value(e) {
          var t = e.event,
              i = e.target,
              n = e.hasFocusedInput,
              r = e.activeItems;
          !n || i.value || this._isSelectOneElement || (this._handleBackspace(r), t.preventDefault());
        }
      }, {
        key: "_onTouchMove",
        value: function value() {
          this._wasTap && (this._wasTap = !1);
        }
      }, {
        key: "_onTouchEnd",
        value: function value(e) {
          var t = (e || e.touches[0]).target;
          this._wasTap && this.containerOuter.element.contains(t) && ((t === this.containerOuter.element || t === this.containerInner.element) && (this._isTextElement ? this.input.focus() : this._isSelectMultipleElement && this.showDropdown()), e.stopPropagation());
          this._wasTap = !0;
        }
      }, {
        key: "_onMouseDown",
        value: function value(e) {
          var t = e.target,
              i = e.shiftKey;

          if (t === this.choiceList && (0, p.isIE11)() && (this._isScrollingOnIe = !0), this.containerOuter.element.contains(t) && t !== this.input.element) {
            var n = this._store.activeItems,
                r = i,
                o = (0, p.findAncestorByAttrName)(t, "data-button"),
                s = (0, p.findAncestorByAttrName)(t, "data-item"),
                a = (0, p.findAncestorByAttrName)(t, "data-choice");
            o ? this._handleButtonAction(n, o) : s ? this._handleItemAction(n, s, r) : a && this._handleChoiceAction(n, a), e.preventDefault();
          }
        }
      }, {
        key: "_onMouseOver",
        value: function value(e) {
          var t = e.target;
          (t === this.dropdown || this.dropdown.element.contains(t)) && t.hasAttribute("data-choice") && this._highlightChoice(t);
        }
      }, {
        key: "_onClick",
        value: function value(e) {
          var t = e.target;
          this.containerOuter.element.contains(t) ? this.dropdown.isActive || this.containerOuter.isDisabled ? this._isSelectOneElement && t !== this.input.element && !this.dropdown.element.contains(t) && this.hideDropdown() : this._isTextElement ? document.activeElement !== this.input.element && this.input.focus() : (this.showDropdown(), this.containerOuter.focus()) : (this._store.highlightedActiveItems && this.unhighlightAll(), this.containerOuter.removeFocusState(), this.hideDropdown(!0));
        }
      }, {
        key: "_onFocus",
        value: function value(e) {
          var t = this,
              i = e.target;
          this.containerOuter.element.contains(i) && {
            text: function text() {
              i === t.input.element && t.containerOuter.addFocusState();
            },
            "select-one": function selectOne() {
              t.containerOuter.addFocusState(), i === t.input.element && t.showDropdown(!0);
            },
            "select-multiple": function selectMultiple() {
              i === t.input.element && (t.showDropdown(!0), t.containerOuter.addFocusState());
            }
          }[this.passedElement.element.type]();
        }
      }, {
        key: "_onBlur",
        value: function value(e) {
          var t = this,
              i = e.target;

          if (this.containerOuter.element.contains(i) && !this._isScrollingOnIe) {
            var n = this._store.activeItems.some(function (e) {
              return e.highlighted;
            });

            ({
              text: function text() {
                i === t.input.element && (t.containerOuter.removeFocusState(), n && t.unhighlightAll(), t.hideDropdown(!0));
              },
              "select-one": function selectOne() {
                t.containerOuter.removeFocusState(), (i === t.input.element || i === t.containerOuter.element && !t._canSearch) && t.hideDropdown(!0);
              },
              "select-multiple": function selectMultiple() {
                i === t.input.element && (t.containerOuter.removeFocusState(), t.hideDropdown(!0), n && t.unhighlightAll());
              }
            })[this.passedElement.element.type]();
          } else this._isScrollingOnIe = !1, this.input.element.focus();
        }
      }, {
        key: "_onFormReset",
        value: function value() {
          this._store.dispatch((0, d.resetTo)(this._initialState));
        }
      }, {
        key: "_highlightChoice",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              i = Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]"));

          if (i.length) {
            var n = t;
            Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState))).forEach(function (t) {
              t.classList.remove(e.config.classNames.highlightedState), t.setAttribute("aria-selected", "false");
            }), n ? this._highlightPosition = i.indexOf(n) : (n = i.length > this._highlightPosition ? i[this._highlightPosition] : i[i.length - 1]) || (n = i[0]), n.classList.add(this.config.classNames.highlightedState), n.setAttribute("aria-selected", "true"), this.passedElement.triggerEvent(a.EVENTS.highlightChoice, {
              el: n
            }), this.dropdown.isActive && (this.input.setActiveDescendant(n.id), this.containerOuter.setActiveDescendant(n.id));
          }
        }
      }, {
        key: "_addItem",
        value: function value(e) {
          var t = e.value,
              i = e.label,
              n = void 0 === i ? null : i,
              r = e.choiceId,
              o = void 0 === r ? -1 : r,
              s = e.groupId,
              c = void 0 === s ? -1 : s,
              l = e.customProperties,
              h = void 0 === l ? null : l,
              d = e.placeholder,
              f = void 0 !== d && d,
              v = e.keyCode,
              m = void 0 === v ? null : v,
              g = (0, p.isType)("String", t) ? t.trim() : t,
              _ = m,
              y = h,
              b = this._store.items,
              E = n || g,
              S = parseInt(o, 10) || -1,
              I = c >= 0 ? this._store.getGroupById(c) : null,
              O = b ? b.length + 1 : 1;
          return this.config.prependValue && (g = this.config.prependValue + g.toString()), this.config.appendValue && (g += this.config.appendValue.toString()), this._store.dispatch((0, u.addItem)({
            value: g,
            label: E,
            id: O,
            choiceId: S,
            groupId: c,
            customProperties: h,
            placeholder: f,
            keyCode: _
          })), this._isSelectOneElement && this.removeActiveItems(O), this.passedElement.triggerEvent(a.EVENTS.addItem, {
            id: O,
            value: g,
            label: E,
            customProperties: y,
            groupValue: I && I.value ? I.value : void 0,
            keyCode: _
          }), this;
        }
      }, {
        key: "_removeItem",
        value: function value(e) {
          if (!e || !(0, p.isType)("Object", e)) return this;
          var t = e.id,
              i = e.value,
              n = e.label,
              r = e.choiceId,
              o = e.groupId,
              s = o >= 0 ? this._store.getGroupById(o) : null;
          return this._store.dispatch((0, u.removeItem)(t, r)), s && s.value ? this.passedElement.triggerEvent(a.EVENTS.removeItem, {
            id: t,
            value: i,
            label: n,
            groupValue: s.value
          }) : this.passedElement.triggerEvent(a.EVENTS.removeItem, {
            id: t,
            value: i,
            label: n
          }), this;
        }
      }, {
        key: "_addChoice",
        value: function value(e) {
          var t = e.value,
              i = e.label,
              n = void 0 === i ? null : i,
              r = e.isSelected,
              o = void 0 !== r && r,
              s = e.isDisabled,
              a = void 0 !== s && s,
              c = e.groupId,
              u = void 0 === c ? -1 : c,
              h = e.customProperties,
              d = void 0 === h ? null : h,
              f = e.placeholder,
              p = void 0 !== f && f,
              v = e.keyCode,
              m = void 0 === v ? null : v;

          if (null != t) {
            var g = this._store.choices,
                _ = n || t,
                y = g ? g.length + 1 : 1,
                b = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(y);

            this._store.dispatch((0, l.addChoice)({
              value: t,
              label: _,
              id: y,
              groupId: u,
              disabled: a,
              elementId: b,
              customProperties: d,
              placeholder: p,
              keyCode: m
            })), o && this._addItem({
              value: t,
              label: _,
              choiceId: y,
              customProperties: d,
              placeholder: p,
              keyCode: m
            });
          }
        }
      }, {
        key: "_clearChoices",
        value: function value() {
          this._store.dispatch((0, l.clearChoices)());
        }
      }, {
        key: "_addGroup",
        value: function value(e) {
          var t = this,
              i = e.group,
              n = e.id,
              r = e.valueKey,
              o = void 0 === r ? "value" : r,
              s = e.labelKey,
              a = void 0 === s ? "label" : s,
              c = (0, p.isType)("Object", i) ? i.choices : Array.from(i.getElementsByTagName("OPTION")),
              l = n || Math.floor(new Date().valueOf() * Math.random()),
              u = !!i.disabled && i.disabled;

          if (c) {
            this._store.dispatch((0, h.addGroup)(i.label, l, !0, u));

            c.forEach(function (e) {
              var i = e.disabled || e.parentNode && e.parentNode.disabled;

              t._addChoice({
                value: e[o],
                label: (0, p.isType)("Object", e) ? e[a] : e.innerHTML,
                isSelected: e.selected,
                isDisabled: i,
                groupId: l,
                customProperties: e.customProperties,
                placeholder: e.placeholder
              });
            });
          } else this._store.dispatch((0, h.addGroup)(i.label, i.id, !1, i.disabled));
        }
      }, {
        key: "_getTemplate",
        value: function value(e) {
          var t;
          if (!e) return null;

          for (var i = this.config, n = i.templates, r = i.classNames, o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++) {
            s[a - 1] = arguments[a];
          }

          return (t = n[e]).call.apply(t, [this, r].concat(s));
        }
      }, {
        key: "_createTemplates",
        value: function value() {
          var e = this.config.callbackOnCreateTemplates,
              t = {};
          e && (0, p.isType)("Function", e) && (t = e.call(this, p.strToEl)), this.config.templates = (0, r["default"])(c.TEMPLATES, t);
        }
      }, {
        key: "_createElements",
        value: function value() {
          this.containerOuter = new s.Container({
            element: this._getTemplate("containerOuter", this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type),
            classNames: this.config.classNames,
            type: this.passedElement.element.type,
            position: this.config.position
          }), this.containerInner = new s.Container({
            element: this._getTemplate("containerInner"),
            classNames: this.config.classNames,
            type: this.passedElement.element.type,
            position: this.config.position
          }), this.input = new s.Input({
            element: this._getTemplate("input"),
            classNames: this.config.classNames,
            type: this.passedElement.element.type
          }), this.choiceList = new s.List({
            element: this._getTemplate("choiceList", this._isSelectOneElement)
          }), this.itemList = new s.List({
            element: this._getTemplate("itemList", this._isSelectOneElement)
          }), this.dropdown = new s.Dropdown({
            element: this._getTemplate("dropdown"),
            classNames: this.config.classNames,
            type: this.passedElement.element.type
          });
        }
      }, {
        key: "_createStructure",
        value: function value() {
          this.passedElement.conceal(), this.containerInner.wrap(this.passedElement.element), this.containerOuter.wrap(this.containerInner.element), this._isSelectOneElement ? this.input.placeholder = this.config.searchPlaceholderValue || "" : this._placeholderValue && (this.input.placeholder = this._placeholderValue, this.input.setWidth(!0)), this.containerOuter.element.appendChild(this.containerInner.element), this.containerOuter.element.appendChild(this.dropdown.element), this.containerInner.element.appendChild(this.itemList.element), this._isTextElement || this.dropdown.element.appendChild(this.choiceList.element), this._isSelectOneElement ? this.config.searchEnabled && this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild) : this.containerInner.element.appendChild(this.input.element), this._isSelectElement ? this._addPredefinedChoices() : this._isTextElement && this._addPredefinedItems();
        }
      }, {
        key: "_addPredefinedChoices",
        value: function value() {
          var e = this,
              t = this.passedElement.optionGroups;

          if (this._highlightPosition = 0, this._isSearching = !1, this._setLoading(!0), t && t.length) {
            var i = this.passedElement.placeholderOption;
            i && "SELECT" === i.parentNode.tagName && this._addChoice({
              value: i.value,
              label: i.innerHTML,
              isSelected: i.selected,
              isDisabled: i.disabled,
              placeholder: !0
            }), t.forEach(function (t) {
              return e._addGroup({
                group: t,
                id: t.id || null
              });
            });
          } else {
            var n = this.passedElement.options,
                r = this.config.sortFn,
                o = this._presetChoices;
            n.forEach(function (e) {
              o.push({
                value: e.value,
                label: e.innerHTML,
                selected: e.selected,
                disabled: e.disabled || e.parentNode.disabled,
                placeholder: e.hasAttribute("placeholder"),
                customProperties: e.getAttribute("data-custom-properties")
              });
            }), this.config.shouldSort && o.sort(r);
            var s = o.some(function (e) {
              return e.selected;
            });
            o.forEach(function (t, i) {
              return function (t, i) {
                var n = t.value,
                    r = t.label,
                    o = t.customProperties,
                    a = t.placeholder;
                if (e._isSelectElement) {
                  if (t.choices) e._addGroup({
                    group: t,
                    id: t.id || null
                  });else {
                    var c = e._isSelectOneElement && !s && 0 === i,
                        l = !!c || t.selected,
                        u = !c && t.disabled;

                    e._addChoice({
                      value: n,
                      label: r,
                      isSelected: l,
                      isDisabled: u,
                      customProperties: o,
                      placeholder: a
                    });
                  }
                } else e._addChoice({
                  value: n,
                  label: r,
                  isSelected: t.selected,
                  isDisabled: t.disabled,
                  customProperties: o,
                  placeholder: a
                });
              }(t, i);
            });
          }

          this._setLoading(!1);
        }
      }, {
        key: "_addPredefinedItems",
        value: function value() {
          var e = this;

          this._presetItems.forEach(function (t) {
            return function (t) {
              var i = (0, p.getType)(t);
              "Object" === i && t.value ? e._addItem({
                value: t.value,
                label: t.label,
                choiceId: t.id,
                customProperties: t.customProperties,
                placeholder: t.placeholder
              }) : "String" === i && e._addItem({
                value: t
              });
            }(t);
          });
        }
      }, {
        key: "_setChoiceOrItem",
        value: function value(e) {
          var t = this;
          ({
            object: function object() {
              e.value && (t._isTextElement ? t._addItem({
                value: e.value,
                label: e.label,
                choiceId: e.id,
                customProperties: e.customProperties,
                placeholder: e.placeholder
              }) : t._addChoice({
                value: e.value,
                label: e.label,
                isSelected: !0,
                isDisabled: !1,
                customProperties: e.customProperties,
                placeholder: e.placeholder
              }));
            },
            string: function string() {
              t._isTextElement ? t._addItem({
                value: e
              }) : t._addChoice({
                value: e,
                label: e,
                isSelected: !0,
                isDisabled: !1
              });
            }
          })[(0, p.getType)(e).toLowerCase()]();
        }
      }, {
        key: "_findAndSelectChoiceByValue",
        value: function value(e) {
          var t = this,
              i = this._store.choices.find(function (i) {
            return t.config.itemComparer(i.value, e);
          });

          i && !i.selected && this._addItem({
            value: i.value,
            label: i.label,
            choiceId: i.id,
            groupId: i.groupId,
            customProperties: i.customProperties,
            placeholder: i.placeholder,
            keyCode: i.keyCode
          });
        }
      }, {
        key: "_generateInstances",
        value: function value(t, i) {
          return t.reduce(function (t, n) {
            return t.push(new e(n, i)), t;
          }, [this]);
        }
      }, {
        key: "_generatePlaceholderValue",
        value: function value() {
          return !this._isSelectOneElement && !!this.config.placeholder && (this.config.placeholderValue || this.passedElement.element.getAttribute("placeholder"));
        }
      }]) && g(t.prototype, i), v && g(t, v), e;
    }();

    _.userDefaults = {}, e.exports = _;
  }, function (e, t, i) {
    /*!
     * Fuse.js v3.4.2 - Lightweight fuzzy-search (http://fusejs.io)
     * 
     * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
     * All Rights Reserved. Apache Software License 2.0
     * 
     * http://www.apache.org/licenses/LICENSE-2.0
     */
    var n;
    n = function n() {
      return function (e) {
        var t = {};

        function i(n) {
          if (t[n]) return t[n].exports;
          var r = t[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return e[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
        }

        return i.m = e, i.c = t, i.d = function (e, t, n) {
          i.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
          });
        }, i.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, i.t = function (e, t) {
          if (1 & t && (e = i(e)), 8 & t) return e;
          if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
          var n = Object.create(null);
          if (i.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var r in e) {
            i.d(n, r, function (t) {
              return e[t];
            }.bind(null, r));
          }
          return n;
        }, i.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e["default"];
          } : function () {
            return e;
          };
          return i.d(t, "a", t), t;
        }, i.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, i.p = "", i(i.s = "./src/index.js");
      }({
        "./src/bitap/bitap_matched_indices.js":
        /*!********************************************!*\
          !*** ./src/bitap/bitap_matched_indices.js ***!
          \********************************************/

        /*! no static exports found */
        function srcBitapBitap_matched_indicesJs(e, t) {
          e.exports = function () {
            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, i = [], n = -1, r = -1, o = 0, s = e.length; o < s; o += 1) {
              var a = e[o];
              a && -1 === n ? n = o : a || -1 === n || ((r = o - 1) - n + 1 >= t && i.push([n, r]), n = -1);
            }

            return e[o - 1] && o - n >= t && i.push([n, o - 1]), i;
          };
        },
        "./src/bitap/bitap_pattern_alphabet.js":
        /*!*********************************************!*\
          !*** ./src/bitap/bitap_pattern_alphabet.js ***!
          \*********************************************/

        /*! no static exports found */
        function srcBitapBitap_pattern_alphabetJs(e, t) {
          e.exports = function (e) {
            for (var t = {}, i = e.length, n = 0; n < i; n += 1) {
              t[e.charAt(n)] = 0;
            }

            for (var r = 0; r < i; r += 1) {
              t[e.charAt(r)] |= 1 << i - r - 1;
            }

            return t;
          };
        },
        "./src/bitap/bitap_regex_search.js":
        /*!*****************************************!*\
          !*** ./src/bitap/bitap_regex_search.js ***!
          \*****************************************/

        /*! no static exports found */
        function srcBitapBitap_regex_searchJs(e, t) {
          var i = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;

          e.exports = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : / +/g,
                r = new RegExp(t.replace(i, "\\$&").replace(n, "|")),
                o = e.match(r),
                s = !!o,
                a = [];
            if (s) for (var c = 0, l = o.length; c < l; c += 1) {
              var u = o[c];
              a.push([e.indexOf(u), u.length - 1]);
            }
            return {
              score: s ? .5 : 1,
              isMatch: s,
              matchedIndices: a
            };
          };
        },
        "./src/bitap/bitap_score.js":
        /*!**********************************!*\
          !*** ./src/bitap/bitap_score.js ***!
          \**********************************/

        /*! no static exports found */
        function srcBitapBitap_scoreJs(e, t) {
          e.exports = function (e, t) {
            var i = t.errors,
                n = void 0 === i ? 0 : i,
                r = t.currentLocation,
                o = void 0 === r ? 0 : r,
                s = t.expectedLocation,
                a = void 0 === s ? 0 : s,
                c = t.distance,
                l = void 0 === c ? 100 : c,
                u = n / e.length,
                h = Math.abs(a - o);
            return l ? u + h / l : h ? 1 : u;
          };
        },
        "./src/bitap/bitap_search.js":
        /*!***********************************!*\
          !*** ./src/bitap/bitap_search.js ***!
          \***********************************/

        /*! no static exports found */
        function srcBitapBitap_searchJs(e, t, i) {
          var n = i(
          /*! ./bitap_score */
          "./src/bitap/bitap_score.js"),
              r = i(
          /*! ./bitap_matched_indices */
          "./src/bitap/bitap_matched_indices.js");

          e.exports = function (e, t, i, o) {
            for (var s = o.location, a = void 0 === s ? 0 : s, c = o.distance, l = void 0 === c ? 100 : c, u = o.threshold, h = void 0 === u ? .6 : u, d = o.findAllMatches, f = void 0 !== d && d, p = o.minMatchCharLength, v = void 0 === p ? 1 : p, m = a, g = e.length, _ = h, y = e.indexOf(t, m), b = t.length, E = [], S = 0; S < g; S += 1) {
              E[S] = 0;
            }

            if (-1 !== y) {
              var I = n(t, {
                errors: 0,
                currentLocation: y,
                expectedLocation: m,
                distance: l
              });

              if (_ = Math.min(I, _), -1 !== (y = e.lastIndexOf(t, m + b))) {
                var O = n(t, {
                  errors: 0,
                  currentLocation: y,
                  expectedLocation: m,
                  distance: l
                });
                _ = Math.min(O, _);
              }
            }

            y = -1;

            for (var C = [], T = 1, w = b + g, k = 1 << b - 1, A = 0; A < b; A += 1) {
              for (var L = 0, P = w; L < P;) {
                n(t, {
                  errors: A,
                  currentLocation: m + P,
                  expectedLocation: m,
                  distance: l
                }) <= _ ? L = P : w = P, P = Math.floor((w - L) / 2 + L);
              }

              w = P;
              var x = Math.max(1, m - P + 1),
                  D = f ? g : Math.min(m + P, g) + b,
                  j = Array(D + 2);
              j[D + 1] = (1 << A) - 1;

              for (var M = D; M >= x; M -= 1) {
                var N = M - 1,
                    F = i[e.charAt(N)];

                if (F && (E[N] = 1), j[M] = (j[M + 1] << 1 | 1) & F, 0 !== A && (j[M] |= (C[M + 1] | C[M]) << 1 | 1 | C[M + 1]), j[M] & k && (T = n(t, {
                  errors: A,
                  currentLocation: N,
                  expectedLocation: m,
                  distance: l
                })) <= _) {
                  if (_ = T, (y = N) <= m) break;
                  x = Math.max(1, 2 * m - y);
                }
              }

              if (n(t, {
                errors: A + 1,
                currentLocation: m,
                expectedLocation: m,
                distance: l
              }) > _) break;
              C = j;
            }

            return {
              isMatch: y >= 0,
              score: 0 === T ? .001 : T,
              matchedIndices: r(E, v)
            };
          };
        },
        "./src/bitap/index.js":
        /*!****************************!*\
          !*** ./src/bitap/index.js ***!
          \****************************/

        /*! no static exports found */
        function srcBitapIndexJs(e, t, i) {
          function n(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
          }

          var r = i(
          /*! ./bitap_regex_search */
          "./src/bitap/bitap_regex_search.js"),
              o = i(
          /*! ./bitap_search */
          "./src/bitap/bitap_search.js"),
              s = i(
          /*! ./bitap_pattern_alphabet */
          "./src/bitap/bitap_pattern_alphabet.js"),
              a = function () {
            function e(t, i) {
              var n = i.location,
                  r = void 0 === n ? 0 : n,
                  o = i.distance,
                  a = void 0 === o ? 100 : o,
                  c = i.threshold,
                  l = void 0 === c ? .6 : c,
                  u = i.maxPatternLength,
                  h = void 0 === u ? 32 : u,
                  d = i.isCaseSensitive,
                  f = void 0 !== d && d,
                  p = i.tokenSeparator,
                  v = void 0 === p ? / +/g : p,
                  m = i.findAllMatches,
                  g = void 0 !== m && m,
                  _ = i.minMatchCharLength,
                  y = void 0 === _ ? 1 : _;
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this.options = {
                location: r,
                distance: a,
                threshold: l,
                maxPatternLength: h,
                isCaseSensitive: f,
                tokenSeparator: v,
                findAllMatches: g,
                minMatchCharLength: y
              }, this.pattern = this.options.isCaseSensitive ? t : t.toLowerCase(), this.pattern.length <= h && (this.patternAlphabet = s(this.pattern));
            }

            var t, i, a;
            return t = e, (i = [{
              key: "search",
              value: function value(e) {
                if (this.options.isCaseSensitive || (e = e.toLowerCase()), this.pattern === e) return {
                  isMatch: !0,
                  score: 0,
                  matchedIndices: [[0, e.length - 1]]
                };
                var t = this.options,
                    i = t.maxPatternLength,
                    n = t.tokenSeparator;
                if (this.pattern.length > i) return r(e, this.pattern, n);
                var s = this.options,
                    a = s.location,
                    c = s.distance,
                    l = s.threshold,
                    u = s.findAllMatches,
                    h = s.minMatchCharLength;
                return o(e, this.pattern, this.patternAlphabet, {
                  location: a,
                  distance: c,
                  threshold: l,
                  findAllMatches: u,
                  minMatchCharLength: h
                });
              }
            }]) && n(t.prototype, i), a && n(t, a), e;
          }();

          e.exports = a;
        },
        "./src/helpers/deep_value.js":
        /*!***********************************!*\
          !*** ./src/helpers/deep_value.js ***!
          \***********************************/

        /*! no static exports found */
        function srcHelpersDeep_valueJs(e, t, i) {
          var n = i(
          /*! ./is_array */
          "./src/helpers/is_array.js");

          e.exports = function (e, t) {
            return function e(t, i, r) {
              if (i) {
                var o = i.indexOf("."),
                    s = i,
                    a = null;
                -1 !== o && (s = i.slice(0, o), a = i.slice(o + 1));
                var c = t[s];
                if (null != c) if (a || "string" != typeof c && "number" != typeof c) {
                  if (n(c)) for (var l = 0, u = c.length; l < u; l += 1) {
                    e(c[l], a, r);
                  } else a && e(c, a, r);
                } else r.push(c.toString());
              } else r.push(t);

              return r;
            }(e, t, []);
          };
        },
        "./src/helpers/is_array.js":
        /*!*********************************!*\
          !*** ./src/helpers/is_array.js ***!
          \*********************************/

        /*! no static exports found */
        function srcHelpersIs_arrayJs(e, t) {
          e.exports = function (e) {
            return Array.isArray ? Array.isArray(e) : "[object Array]" === Object.prototype.toString.call(e);
          };
        },
        "./src/index.js":
        /*!**********************!*\
          !*** ./src/index.js ***!
          \**********************/

        /*! no static exports found */
        function srcIndexJs(e, t, i) {
          function n(e) {
            return (n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            })(e);
          }

          function r(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
          }

          var o = i(
          /*! ./bitap */
          "./src/bitap/index.js"),
              s = i(
          /*! ./helpers/deep_value */
          "./src/helpers/deep_value.js"),
              a = i(
          /*! ./helpers/is_array */
          "./src/helpers/is_array.js"),
              c = function () {
            function e(t, i) {
              var n = i.location,
                  r = void 0 === n ? 0 : n,
                  o = i.distance,
                  a = void 0 === o ? 100 : o,
                  c = i.threshold,
                  l = void 0 === c ? .6 : c,
                  u = i.maxPatternLength,
                  h = void 0 === u ? 32 : u,
                  d = i.caseSensitive,
                  f = void 0 !== d && d,
                  p = i.tokenSeparator,
                  v = void 0 === p ? / +/g : p,
                  m = i.findAllMatches,
                  g = void 0 !== m && m,
                  _ = i.minMatchCharLength,
                  y = void 0 === _ ? 1 : _,
                  b = i.id,
                  E = void 0 === b ? null : b,
                  S = i.keys,
                  I = void 0 === S ? [] : S,
                  O = i.shouldSort,
                  C = void 0 === O || O,
                  T = i.getFn,
                  w = void 0 === T ? s : T,
                  k = i.sortFn,
                  A = void 0 === k ? function (e, t) {
                return e.score - t.score;
              } : k,
                  L = i.tokenize,
                  P = void 0 !== L && L,
                  x = i.matchAllTokens,
                  D = void 0 !== x && x,
                  j = i.includeMatches,
                  M = void 0 !== j && j,
                  N = i.includeScore,
                  F = void 0 !== N && N,
                  K = i.verbose,
                  R = void 0 !== K && K;
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this.options = {
                location: r,
                distance: a,
                threshold: l,
                maxPatternLength: h,
                isCaseSensitive: f,
                tokenSeparator: v,
                findAllMatches: g,
                minMatchCharLength: y,
                id: E,
                keys: I,
                includeMatches: M,
                includeScore: F,
                shouldSort: C,
                getFn: w,
                sortFn: A,
                verbose: R,
                tokenize: P,
                matchAllTokens: D
              }, this.setCollection(t);
            }

            var t, i, c;
            return t = e, (i = [{
              key: "setCollection",
              value: function value(e) {
                return this.list = e, e;
              }
            }, {
              key: "search",
              value: function value(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                  limit: !1
                };

                this._log('---------\nSearch pattern: "'.concat(e, '"'));

                var i = this._prepareSearchers(e),
                    n = i.tokenSearchers,
                    r = i.fullSearcher,
                    o = this._search(n, r),
                    s = o.weights,
                    a = o.results;

                return this._computeScore(s, a), this.options.shouldSort && this._sort(a), t.limit && "number" == typeof t.limit && (a = a.slice(0, t.limit)), this._format(a);
              }
            }, {
              key: "_prepareSearchers",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                    t = [];
                if (this.options.tokenize) for (var i = e.split(this.options.tokenSeparator), n = 0, r = i.length; n < r; n += 1) {
                  t.push(new o(i[n], this.options));
                }
                return {
                  tokenSearchers: t,
                  fullSearcher: new o(e, this.options)
                };
              }
            }, {
              key: "_search",
              value: function value() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                    t = arguments.length > 1 ? arguments[1] : void 0,
                    i = this.list,
                    n = {},
                    r = [];

                if ("string" == typeof i[0]) {
                  for (var o = 0, s = i.length; o < s; o += 1) {
                    this._analyze({
                      key: "",
                      value: i[o],
                      record: o,
                      index: o
                    }, {
                      resultMap: n,
                      results: r,
                      tokenSearchers: e,
                      fullSearcher: t
                    });
                  }

                  return {
                    weights: null,
                    results: r
                  };
                }

                for (var a = {}, c = 0, l = i.length; c < l; c += 1) {
                  for (var u = i[c], h = 0, d = this.options.keys.length; h < d; h += 1) {
                    var f = this.options.keys[h];

                    if ("string" != typeof f) {
                      if (a[f.name] = {
                        weight: 1 - f.weight || 1
                      }, f.weight <= 0 || f.weight > 1) throw new Error("Key weight has to be > 0 and <= 1");
                      f = f.name;
                    } else a[f] = {
                      weight: 1
                    };

                    this._analyze({
                      key: f,
                      value: this.options.getFn(u, f),
                      record: u,
                      index: c
                    }, {
                      resultMap: n,
                      results: r,
                      tokenSearchers: e,
                      fullSearcher: t
                    });
                  }
                }

                return {
                  weights: a,
                  results: r
                };
              }
            }, {
              key: "_analyze",
              value: function value(e, t) {
                var i = e.key,
                    n = e.arrayIndex,
                    r = void 0 === n ? -1 : n,
                    o = e.value,
                    s = e.record,
                    c = e.index,
                    l = t.tokenSearchers,
                    u = void 0 === l ? [] : l,
                    h = t.fullSearcher,
                    d = void 0 === h ? [] : h,
                    f = t.resultMap,
                    p = void 0 === f ? {} : f,
                    v = t.results,
                    m = void 0 === v ? [] : v;

                if (null != o) {
                  var g = !1,
                      _ = -1,
                      y = 0;

                  if ("string" == typeof o) {
                    this._log("\nKey: ".concat("" === i ? "-" : i));

                    var b = d.search(o);

                    if (this._log('Full text: "'.concat(o, '", score: ').concat(b.score)), this.options.tokenize) {
                      for (var E = o.split(this.options.tokenSeparator), S = [], I = 0; I < u.length; I += 1) {
                        var O = u[I];

                        this._log('\nPattern: "'.concat(O.pattern, '"'));

                        for (var C = !1, T = 0; T < E.length; T += 1) {
                          var w = E[T],
                              k = O.search(w),
                              A = {};
                          k.isMatch ? (A[w] = k.score, g = !0, C = !0, S.push(k.score)) : (A[w] = 1, this.options.matchAllTokens || S.push(1)), this._log('Token: "'.concat(w, '", score: ').concat(A[w]));
                        }

                        C && (y += 1);
                      }

                      _ = S[0];

                      for (var L = S.length, P = 1; P < L; P += 1) {
                        _ += S[P];
                      }

                      _ /= L, this._log("Token score average:", _);
                    }

                    var x = b.score;
                    _ > -1 && (x = (x + _) / 2), this._log("Score average:", x);
                    var D = !this.options.tokenize || !this.options.matchAllTokens || y >= u.length;

                    if (this._log("\nCheck Matches: ".concat(D)), (g || b.isMatch) && D) {
                      var j = p[c];
                      j ? j.output.push({
                        key: i,
                        arrayIndex: r,
                        value: o,
                        score: x,
                        matchedIndices: b.matchedIndices
                      }) : (p[c] = {
                        item: s,
                        output: [{
                          key: i,
                          arrayIndex: r,
                          value: o,
                          score: x,
                          matchedIndices: b.matchedIndices
                        }]
                      }, m.push(p[c]));
                    }
                  } else if (a(o)) for (var M = 0, N = o.length; M < N; M += 1) {
                    this._analyze({
                      key: i,
                      arrayIndex: M,
                      value: o[M],
                      record: s,
                      index: c
                    }, {
                      resultMap: p,
                      results: m,
                      tokenSearchers: u,
                      fullSearcher: d
                    });
                  }
                }
              }
            }, {
              key: "_computeScore",
              value: function value(e, t) {
                this._log("\n\nComputing score:\n");

                for (var i = 0, n = t.length; i < n; i += 1) {
                  for (var r = t[i].output, o = r.length, s = 1, a = 1, c = 0; c < o; c += 1) {
                    var l = e ? e[r[c].key].weight : 1,
                        u = (1 === l ? r[c].score : r[c].score || .001) * l;
                    1 !== l ? a = Math.min(a, u) : (r[c].nScore = u, s *= u);
                  }

                  t[i].score = 1 === a ? s : a, this._log(t[i]);
                }
              }
            }, {
              key: "_sort",
              value: function value(e) {
                this._log("\n\nSorting...."), e.sort(this.options.sortFn);
              }
            }, {
              key: "_format",
              value: function value(e) {
                var t = [];

                if (this.options.verbose) {
                  var i = [];
                  this._log("\n\nOutput:\n\n", JSON.stringify(e, function (e, t) {
                    if ("object" === n(t) && null !== t) {
                      if (-1 !== i.indexOf(t)) return;
                      i.push(t);
                    }

                    return t;
                  })), i = null;
                }

                var r = [];
                this.options.includeMatches && r.push(function (e, t) {
                  var i = e.output;
                  t.matches = [];

                  for (var n = 0, r = i.length; n < r; n += 1) {
                    var o = i[n];

                    if (0 !== o.matchedIndices.length) {
                      var s = {
                        indices: o.matchedIndices,
                        value: o.value
                      };
                      o.key && (s.key = o.key), o.hasOwnProperty("arrayIndex") && o.arrayIndex > -1 && (s.arrayIndex = o.arrayIndex), t.matches.push(s);
                    }
                  }
                }), this.options.includeScore && r.push(function (e, t) {
                  t.score = e.score;
                });

                for (var o = 0, s = e.length; o < s; o += 1) {
                  var a = e[o];

                  if (this.options.id && (a.item = this.options.getFn(a.item, this.options.id)[0]), r.length) {
                    for (var c = {
                      item: a.item
                    }, l = 0, u = r.length; l < u; l += 1) {
                      r[l](a, c);
                    }

                    t.push(c);
                  } else t.push(a.item);
                }

                return t;
              }
            }, {
              key: "_log",
              value: function value() {
                var e;
                this.options.verbose && (e = console).log.apply(e, arguments);
              }
            }]) && r(t.prototype, i), c && r(t, c), e;
          }();

          e.exports = c;
        }
      });
    }, e.exports = n();
  }, function (e, t, i) {
    "use strict";

    i.r(t);

    var n = function n(e) {
      return function (e) {
        return !!e && "object" == _typeof(e);
      }(e) && !function (e) {
        var t = Object.prototype.toString.call(e);
        return "[object RegExp]" === t || "[object Date]" === t || function (e) {
          return e.$$typeof === r;
        }(e);
      }(e);
    };

    var r = "function" == typeof Symbol && Symbol["for"] ? Symbol["for"]("react.element") : 60103;

    function o(e, t) {
      return !1 !== t.clone && t.isMergeableObject(e) ? a((i = e, Array.isArray(i) ? [] : {}), e, t) : e;
      var i;
    }

    function s(e, t, i) {
      return e.concat(t).map(function (e) {
        return o(e, i);
      });
    }

    function a(e, t, i) {
      (i = i || {}).arrayMerge = i.arrayMerge || s, i.isMergeableObject = i.isMergeableObject || n;
      var r = Array.isArray(t);
      return r === Array.isArray(e) ? r ? i.arrayMerge(e, t, i) : function (e, t, i) {
        var n = {};
        return i.isMergeableObject(e) && Object.keys(e).forEach(function (t) {
          n[t] = o(e[t], i);
        }), Object.keys(t).forEach(function (r) {
          i.isMergeableObject(t[r]) && e[r] ? n[r] = a(e[r], t[r], i) : n[r] = o(t[r], i);
        }), n;
      }(e, t, i) : o(t, i);
    }

    a.all = function (e, t) {
      if (!Array.isArray(e)) throw new Error("first argument should be an array");
      return e.reduce(function (e, i) {
        return a(e, i, t);
      }, {});
    };

    var c = a;
    t["default"] = c;
  }, function (e, t, i) {
    "use strict";

    i(14);
  }, function (e, t) {
    try {
      var i = new window.CustomEvent("test");
      if (i.preventDefault(), !0 !== i.defaultPrevented) throw new Error("Could not prevent default");
    } catch (e) {
      var n = function n(e, t) {
        var i, n;
        return t = t || {
          bubbles: !1,
          cancelable: !1,
          detail: void 0
        }, (i = document.createEvent("CustomEvent")).initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n = i.preventDefault, i.preventDefault = function () {
          n.call(this);

          try {
            Object.defineProperty(this, "defaultPrevented", {
              get: function get() {
                return !0;
              }
            });
          } catch (e) {
            this.defaultPrevented = !0;
          }
        }, i;
      };

      n.prototype = window.Event.prototype, window.CustomEvent = n;
    }
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n,
        r = i(6),
        o = (n = i(17)) && n.__esModule ? n : {
      "default": n
    };

    function s(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    var a = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._store = (0, r.createStore)(o["default"], window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
      }

      var t, i, n;
      return t = e, (i = [{
        key: "subscribe",
        value: function value(e) {
          this._store.subscribe(e);
        }
      }, {
        key: "dispatch",
        value: function value(e) {
          this._store.dispatch(e);
        }
      }, {
        key: "isLoading",
        value: function value() {
          return this.state.general.loading;
        }
      }, {
        key: "getChoiceById",
        value: function value(e) {
          return !!e && this.activeChoices.find(function (t) {
            return t.id === parseInt(e, 10);
          });
        }
      }, {
        key: "getGroupById",
        value: function value(e) {
          return this.groups.find(function (t) {
            return t.id === parseInt(e, 10);
          });
        }
      }, {
        key: "state",
        get: function get() {
          return this._store.getState();
        }
      }, {
        key: "items",
        get: function get() {
          return this.state.items;
        }
      }, {
        key: "activeItems",
        get: function get() {
          return this.items.filter(function (e) {
            return !0 === e.active;
          });
        }
      }, {
        key: "highlightedActiveItems",
        get: function get() {
          return this.items.filter(function (e) {
            return e.active && e.highlighted;
          });
        }
      }, {
        key: "choices",
        get: function get() {
          return this.state.choices;
        }
      }, {
        key: "activeChoices",
        get: function get() {
          return this.choices.filter(function (e) {
            return !0 === e.active;
          });
        }
      }, {
        key: "selectableChoices",
        get: function get() {
          return this.choices.filter(function (e) {
            return !0 !== e.disabled;
          });
        }
      }, {
        key: "searchableChoices",
        get: function get() {
          return this.selectableChoices.filter(function (e) {
            return !0 !== e.placeholder;
          });
        }
      }, {
        key: "placeholderChoice",
        get: function get() {
          return [].concat(this.choices).reverse().find(function (e) {
            return !0 === e.placeholder;
          });
        }
      }, {
        key: "groups",
        get: function get() {
          return this.state.groups;
        }
      }, {
        key: "activeGroups",
        get: function get() {
          var e = this.groups,
              t = this.choices;
          return e.filter(function (e) {
            var i = !0 === e.active && !1 === e.disabled,
                n = t.some(function (e) {
              return !0 === e.active && !1 === e.disabled;
            });
            return i && n;
          }, []);
        }
      }]) && s(t.prototype, i), n && s(t, n), e;
    }();

    t["default"] = a;
  }, function (e, t) {
    e.exports = function (e) {
      if (!e.webpackPolyfill) {
        var t = Object.create(e);
        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function get() {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function get() {
            return t.i;
          }
        }), Object.defineProperty(t, "exports", {
          enumerable: !0
        }), t.webpackPolyfill = 1;
      }

      return t;
    };
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n = i(6),
        r = l(i(18)),
        o = l(i(19)),
        s = l(i(20)),
        a = l(i(21)),
        c = i(0);

    function l(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    var u = (0, n.combineReducers)({
      items: r["default"],
      groups: o["default"],
      choices: s["default"],
      general: a["default"]
    }),
        h = function h(e, t) {
      var i = e;
      if ("CLEAR_ALL" === t.type) i = void 0;else if ("RESET_TO" === t.type) return (0, c.cloneObject)(t.state);
      return u(i, t);
    };

    t["default"] = h;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "ADD_ITEM":
          var i = [].concat(e, [{
            id: t.id,
            choiceId: t.choiceId,
            groupId: t.groupId,
            value: t.value,
            label: t.label,
            active: !0,
            highlighted: !1,
            customProperties: t.customProperties,
            placeholder: t.placeholder || !1,
            keyCode: null
          }]);
          return i.map(function (e) {
            var t = e;
            return t.highlighted = !1, t;
          });

        case "REMOVE_ITEM":
          return e.map(function (e) {
            var i = e;
            return i.id === t.id && (i.active = !1), i;
          });

        case "HIGHLIGHT_ITEM":
          return e.map(function (e) {
            var i = e;
            return i.id === t.id && (i.highlighted = t.highlighted), i;
          });

        default:
          return e;
      }
    }, t.defaultState = void 0;
    var n = [];
    t.defaultState = n;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "ADD_GROUP":
          return [].concat(e, [{
            id: t.id,
            value: t.value,
            active: t.active,
            disabled: t.disabled
          }]);

        case "CLEAR_CHOICES":
          return [];

        default:
          return e;
      }
    }, t.defaultState = void 0;
    var n = [];
    t.defaultState = n;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "ADD_CHOICE":
          return [].concat(e, [{
            id: t.id,
            elementId: t.elementId,
            groupId: t.groupId,
            value: t.value,
            label: t.label || t.value,
            disabled: t.disabled || !1,
            selected: !1,
            active: !0,
            score: 9999,
            customProperties: t.customProperties,
            placeholder: t.placeholder || !1,
            keyCode: null
          }]);

        case "ADD_ITEM":
          return t.activateOptions ? e.map(function (e) {
            var i = e;
            return i.active = t.active, i;
          }) : t.choiceId > -1 ? e.map(function (e) {
            var i = e;
            return i.id === parseInt(t.choiceId, 10) && (i.selected = !0), i;
          }) : e;

        case "REMOVE_ITEM":
          return t.choiceId > -1 ? e.map(function (e) {
            var i = e;
            return i.id === parseInt(t.choiceId, 10) && (i.selected = !1), i;
          }) : e;

        case "FILTER_CHOICES":
          return e.map(function (e) {
            var i = e;
            return i.active = t.results.some(function (e) {
              var t = e.item,
                  n = e.score;
              return t.id === i.id && (i.score = n, !0);
            }), i;
          });

        case "ACTIVATE_CHOICES":
          return e.map(function (e) {
            var i = e;
            return i.active = t.active, i;
          });

        case "CLEAR_CHOICES":
          return n;

        default:
          return e;
      }
    }, t.defaultState = void 0;
    var n = [];
    t.defaultState = n;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = t.defaultState = void 0;
    var n = {
      loading: !1
    };
    t.defaultState = n;

    var r = function r() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "SET_IS_LOADING":
          return {
            loading: t.isLoading
          };

        default:
          return e;
      }
    };

    t["default"] = r;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "Dropdown", {
      enumerable: !0,
      get: function get() {
        return n["default"];
      }
    }), Object.defineProperty(t, "Container", {
      enumerable: !0,
      get: function get() {
        return r["default"];
      }
    }), Object.defineProperty(t, "Input", {
      enumerable: !0,
      get: function get() {
        return o["default"];
      }
    }), Object.defineProperty(t, "List", {
      enumerable: !0,
      get: function get() {
        return s["default"];
      }
    }), Object.defineProperty(t, "WrappedInput", {
      enumerable: !0,
      get: function get() {
        return a["default"];
      }
    }), Object.defineProperty(t, "WrappedSelect", {
      enumerable: !0,
      get: function get() {
        return c["default"];
      }
    });
    var n = l(i(23)),
        r = l(i(24)),
        o = l(i(25)),
        s = l(i(26)),
        a = l(i(27)),
        c = l(i(28));

    function l(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;

    var r = function () {
      function e(t) {
        var i = t.element,
            n = t.type,
            r = t.classNames;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Object.assign(this, {
          element: i,
          type: n,
          classNames: r
        }), this.isActive = !1;
      }

      var t, i, r;
      return t = e, (i = [{
        key: "distanceFromTopWindow",
        value: function value() {
          return this.dimensions = this.element.getBoundingClientRect(), this.position = Math.ceil(this.dimensions.top + window.pageYOffset + this.element.offsetHeight), this.position;
        }
      }, {
        key: "getChild",
        value: function value(e) {
          return this.element.querySelector(e);
        }
      }, {
        key: "show",
        value: function value() {
          return this.element.classList.add(this.classNames.activeState), this.element.setAttribute("aria-expanded", "true"), this.isActive = !0, this;
        }
      }, {
        key: "hide",
        value: function value() {
          return this.element.classList.remove(this.classNames.activeState), this.element.setAttribute("aria-expanded", "false"), this.isActive = !1, this;
        }
      }]) && n(t.prototype, i), r && n(t, r), e;
    }();

    t["default"] = r;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n = i(0);

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    var o = function () {
      function e(t) {
        var i = t.element,
            n = t.type,
            r = t.classNames,
            o = t.position;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Object.assign(this, {
          element: i,
          classNames: r,
          type: n,
          position: o
        }), this.isOpen = !1, this.isFlipped = !1, this.isFocussed = !1, this.isDisabled = !1, this.isLoading = !1, this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this);
      }

      var t, i, o;
      return t = e, (i = [{
        key: "addEventListeners",
        value: function value() {
          this.element.addEventListener("focus", this._onFocus), this.element.addEventListener("blur", this._onBlur);
        }
      }, {
        key: "removeEventListeners",
        value: function value() {
          this.element.removeEventListener("focus", this._onFocus), this.element.removeEventListener("blur", this._onBlur);
        }
      }, {
        key: "shouldFlip",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (0, n.getWindowHeight)();
          if (void 0 === e) return !1;
          var i = !1;
          return "auto" === this.position ? i = e >= t : "top" === this.position && (i = !0), i;
        }
      }, {
        key: "setActiveDescendant",
        value: function value(e) {
          this.element.setAttribute("aria-activedescendant", e);
        }
      }, {
        key: "removeActiveDescendant",
        value: function value() {
          this.element.removeAttribute("aria-activedescendant");
        }
      }, {
        key: "open",
        value: function value(e) {
          this.element.classList.add(this.classNames.openState), this.element.setAttribute("aria-expanded", "true"), this.isOpen = !0, this.shouldFlip(e) && (this.element.classList.add(this.classNames.flippedState), this.isFlipped = !0);
        }
      }, {
        key: "close",
        value: function value() {
          this.element.classList.remove(this.classNames.openState), this.element.setAttribute("aria-expanded", "false"), this.removeActiveDescendant(), this.isOpen = !1, this.isFlipped && (this.element.classList.remove(this.classNames.flippedState), this.isFlipped = !1);
        }
      }, {
        key: "focus",
        value: function value() {
          this.isFocussed || this.element.focus();
        }
      }, {
        key: "addFocusState",
        value: function value() {
          this.element.classList.add(this.classNames.focusState);
        }
      }, {
        key: "removeFocusState",
        value: function value() {
          this.element.classList.remove(this.classNames.focusState);
        }
      }, {
        key: "enable",
        value: function value() {
          this.element.classList.remove(this.classNames.disabledState), this.element.removeAttribute("aria-disabled"), "select-one" === this.type && this.element.setAttribute("tabindex", "0"), this.isDisabled = !1;
        }
      }, {
        key: "disable",
        value: function value() {
          this.element.classList.add(this.classNames.disabledState), this.element.setAttribute("aria-disabled", "true"), "select-one" === this.type && this.element.setAttribute("tabindex", "-1"), this.isDisabled = !0;
        }
      }, {
        key: "wrap",
        value: function value(e) {
          (0, n.wrap)(e, this.element);
        }
      }, {
        key: "unwrap",
        value: function value(e) {
          this.element.parentNode.insertBefore(e, this.element), this.element.parentNode.removeChild(this.element);
        }
      }, {
        key: "addLoadingState",
        value: function value() {
          this.element.classList.add(this.classNames.loadingState), this.element.setAttribute("aria-busy", "true"), this.isLoading = !0;
        }
      }, {
        key: "removeLoadingState",
        value: function value() {
          this.element.classList.remove(this.classNames.loadingState), this.element.removeAttribute("aria-busy"), this.isLoading = !1;
        }
      }, {
        key: "_onFocus",
        value: function value() {
          this.isFocussed = !0;
        }
      }, {
        key: "_onBlur",
        value: function value() {
          this.isFocussed = !1;
        }
      }]) && r(t.prototype, i), o && r(t, o), e;
    }();

    t["default"] = o;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n = i(0);

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    var o = function () {
      function e(t) {
        var i = t.element,
            n = t.type,
            r = t.classNames,
            o = t.placeholderValue;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Object.assign(this, {
          element: i,
          type: n,
          classNames: r,
          placeholderValue: o
        }), this.element = i, this.classNames = r, this.isFocussed = this.element === document.activeElement, this.isDisabled = !1, this._onPaste = this._onPaste.bind(this), this._onInput = this._onInput.bind(this), this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this);
      }

      var t, i, o;
      return t = e, (i = [{
        key: "addEventListeners",
        value: function value() {
          this.element.addEventListener("input", this._onInput), this.element.addEventListener("paste", this._onPaste), this.element.addEventListener("focus", this._onFocus), this.element.addEventListener("blur", this._onBlur), this.element.form && this.element.form.addEventListener("reset", this._onFormReset);
        }
      }, {
        key: "removeEventListeners",
        value: function value() {
          this.element.removeEventListener("input", this._onInput), this.element.removeEventListener("paste", this._onPaste), this.element.removeEventListener("focus", this._onFocus), this.element.removeEventListener("blur", this._onBlur), this.element.form && this.element.form.removeEventListener("reset", this._onFormReset);
        }
      }, {
        key: "enable",
        value: function value() {
          this.element.removeAttribute("disabled"), this.isDisabled = !1;
        }
      }, {
        key: "disable",
        value: function value() {
          this.element.setAttribute("disabled", ""), this.isDisabled = !0;
        }
      }, {
        key: "focus",
        value: function value() {
          this.isFocussed || this.element.focus();
        }
      }, {
        key: "blur",
        value: function value() {
          this.isFocussed && this.element.blur();
        }
      }, {
        key: "clear",
        value: function value() {
          var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          return this.element.value && (this.element.value = ""), e && this.setWidth(), this;
        }
      }, {
        key: "setWidth",
        value: function value(e) {
          var t = this,
              i = function i(e) {
            t.element.style.width = e;
          };

          if (this._placeholderValue) {
            var n = this.element.value.length >= this._placeholderValue.length / 1.25;
            (this.element.value && n || e) && this.calcWidth(i);
          } else this.calcWidth(i);
        }
      }, {
        key: "calcWidth",
        value: function value(e) {
          return (0, n.calcWidthOfInput)(this.element, e);
        }
      }, {
        key: "setActiveDescendant",
        value: function value(e) {
          this.element.setAttribute("aria-activedescendant", e);
        }
      }, {
        key: "removeActiveDescendant",
        value: function value() {
          this.element.removeAttribute("aria-activedescendant");
        }
      }, {
        key: "_onInput",
        value: function value() {
          "select-one" !== this.type && this.setWidth();
        }
      }, {
        key: "_onPaste",
        value: function value(e) {
          e.target === this.element && this.preventPaste && e.preventDefault();
        }
      }, {
        key: "_onFocus",
        value: function value() {
          this.isFocussed = !0;
        }
      }, {
        key: "_onBlur",
        value: function value() {
          this.isFocussed = !1;
        }
      }, {
        key: "placeholder",
        set: function set(e) {
          this.element.placeholder = e;
        }
      }, {
        key: "value",
        set: function set(e) {
          this.element.value = e;
        },
        get: function get() {
          return (0, n.sanitise)(this.element.value);
        }
      }]) && r(t.prototype, i), o && r(t, o), e;
    }();

    t["default"] = o;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n = i(1);

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    var o = function () {
      function e(t) {
        var i = t.element;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Object.assign(this, {
          element: i
        }), this.scrollPos = this.element.scrollTop, this.height = this.element.offsetHeight, this.hasChildren = !!this.element.children;
      }

      var t, i, o;
      return t = e, (i = [{
        key: "clear",
        value: function value() {
          this.element.innerHTML = "";
        }
      }, {
        key: "append",
        value: function value(e) {
          this.element.appendChild(e);
        }
      }, {
        key: "getChild",
        value: function value(e) {
          return this.element.querySelector(e);
        }
      }, {
        key: "scrollToTop",
        value: function value() {
          this.element.scrollTop = 0;
        }
      }, {
        key: "scrollToChoice",
        value: function value(e, t) {
          var i = this;

          if (e) {
            var n = this.element.offsetHeight,
                r = e.offsetHeight,
                o = e.offsetTop + r,
                s = this.element.scrollTop + n,
                a = t > 0 ? this.element.scrollTop + o - s : e.offsetTop;
            requestAnimationFrame(function (e) {
              i._animateScroll(e, a, t);
            });
          }
        }
      }, {
        key: "_scrollDown",
        value: function value(e, t, i) {
          var n = (i - e) / t,
              r = n > 1 ? n : 1;
          this.element.scrollTop = e + r;
        }
      }, {
        key: "_scrollUp",
        value: function value(e, t, i) {
          var n = (e - i) / t,
              r = n > 1 ? n : 1;
          this.element.scrollTop = e - r;
        }
      }, {
        key: "_animateScroll",
        value: function value(e, t, i) {
          var r = this,
              o = n.SCROLLING_SPEED,
              s = this.element.scrollTop,
              a = !1;
          i > 0 ? (this._scrollDown(s, o, t), s < t && (a = !0)) : (this._scrollUp(s, o, t), s > t && (a = !0)), a && requestAnimationFrame(function () {
            r._animateScroll(e, t, i);
          });
        }
      }]) && r(t.prototype, i), o && r(t, o), e;
    }();

    t["default"] = o;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n,
        r = (n = i(4)) && n.__esModule ? n : {
      "default": n
    };

    function o(e) {
      return (o = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function s(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function a(e, t) {
      return !t || "object" !== o(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function c(e, t, i) {
      return (c = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, i) {
        var n = function (e, t) {
          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = l(e));) {
            ;
          }

          return e;
        }(e, t);

        if (n) {
          var r = Object.getOwnPropertyDescriptor(n, t);
          return r.get ? r.get.call(i) : r.value;
        }
      })(e, t, i || e);
    }

    function l(e) {
      return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function u(e, t) {
      return (u = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var h = function (e) {
      function t(e) {
        var i,
            n = e.element,
            r = e.classNames,
            o = e.delimiter;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (i = a(this, l(t).call(this, {
          element: n,
          classNames: r
        }))).delimiter = o, i;
      }

      var i, n, o;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && u(e, t);
      }(t, r["default"]), i = t, (n = [{
        key: "value",
        set: function set(e) {
          var t = e.map(function (e) {
            return e.value;
          }).join(this.delimiter);
          this.element.setAttribute("value", t), this.element.value = t;
        },
        get: function get() {
          return c(l(t.prototype), "value", this);
        }
      }]) && s(i.prototype, n), o && s(i, o), t;
    }();

    t["default"] = h;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var n = o(i(4)),
        r = o(i(5));

    function o(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function s(e) {
      return (s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function a(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function c(e, t) {
      return !t || "object" !== s(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function l(e) {
      return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function u(e, t) {
      return (u = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var h = function (e) {
      function t(e) {
        var i = e.element,
            n = e.classNames;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), c(this, l(t).call(this, {
          element: i,
          classNames: n
        }));
      }

      var i, o, s;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && u(e, t);
      }(t, n["default"]), i = t, (o = [{
        key: "appendDocFragment",
        value: function value(e) {
          this.element.innerHTML = "", this.element.appendChild(e);
        }
      }, {
        key: "placeholderOption",
        get: function get() {
          return this.element.querySelector("option[placeholder]");
        }
      }, {
        key: "optionGroups",
        get: function get() {
          return Array.from(this.element.getElementsByTagName("OPTGROUP"));
        }
      }, {
        key: "options",
        get: function get() {
          return Array.from(this.element.options);
        },
        set: function set(e) {
          var t = document.createDocumentFragment();
          e.forEach(function (e) {
            return i = e, n = r["default"].option(i), void t.appendChild(n);
            var i, n;
          }), this.appendDocFragment(t);
        }
      }]) && a(i.prototype, o), s && a(i, s), t;
    }();

    t["default"] = h;
  }, function (e, t, i) {
    var n;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var i = {}.hasOwnProperty;

      function r() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var o = _typeof(n);

            if ("string" === o || "number" === o) e.push(n);else if (Array.isArray(n) && n.length) {
              var s = r.apply(null, n);
              s && e.push(s);
            } else if ("object" === o) for (var a in n) {
              i.call(n, a) && n[a] && e.push(a);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (r["default"] = r, e.exports = r) : void 0 === (n = function () {
        return r;
      }.apply(t, [])) || (e.exports = n);
    }();
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.clearChoices = t.activateChoices = t.filterChoices = t.addChoice = void 0;
    var n = i(1);

    t.addChoice = function (e) {
      var t = e.value,
          i = e.label,
          r = e.id,
          o = e.groupId,
          s = e.disabled,
          a = e.elementId,
          c = e.customProperties,
          l = e.placeholder,
          u = e.keyCode;
      return {
        type: n.ACTION_TYPES.ADD_CHOICE,
        value: t,
        label: i,
        id: r,
        groupId: o,
        disabled: s,
        elementId: a,
        customProperties: c,
        placeholder: l,
        keyCode: u
      };
    };

    t.filterChoices = function (e) {
      return {
        type: n.ACTION_TYPES.FILTER_CHOICES,
        results: e
      };
    };

    t.activateChoices = function () {
      var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
      return {
        type: n.ACTION_TYPES.ACTIVATE_CHOICES,
        active: e
      };
    };

    t.clearChoices = function () {
      return {
        type: n.ACTION_TYPES.CLEAR_CHOICES
      };
    };
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.highlightItem = t.removeItem = t.addItem = void 0;
    var n = i(1);

    t.addItem = function (e) {
      var t = e.value,
          i = e.label,
          r = e.id,
          o = e.choiceId,
          s = e.groupId,
          a = e.customProperties,
          c = e.placeholder,
          l = e.keyCode;
      return {
        type: n.ACTION_TYPES.ADD_ITEM,
        value: t,
        label: i,
        id: r,
        choiceId: o,
        groupId: s,
        customProperties: a,
        placeholder: c,
        keyCode: l
      };
    };

    t.removeItem = function (e, t) {
      return {
        type: n.ACTION_TYPES.REMOVE_ITEM,
        id: e,
        choiceId: t
      };
    };

    t.highlightItem = function (e, t) {
      return {
        type: n.ACTION_TYPES.HIGHLIGHT_ITEM,
        id: e,
        highlighted: t
      };
    };
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.addGroup = void 0;
    var n = i(1);

    t.addGroup = function (e, t, i, r) {
      return {
        type: n.ACTION_TYPES.ADD_GROUP,
        value: e,
        id: t,
        active: i,
        disabled: r
      };
    };
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.resetTo = t.clearAll = void 0;

    t.clearAll = function () {
      return {
        type: "CLEAR_ALL"
      };
    };

    t.resetTo = function (e) {
      return {
        type: "RESET_TO",
        state: e
      };
    };
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.setIsLoading = void 0;

    t.setIsLoading = function (e) {
      return {
        type: "SET_IS_LOADING",
        isLoading: e
      };
    };
  }]);
});